import { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../customComponents/Button";
import Paper from "../../widgets/Paper";
import InputText from "../../customComponents/InputText";
import Select from "../../customComponents/Select";
import Upload from "../../customComponents/Upload";
import { post } from "../../utils/api";
import { toast, ToastContainer } from "react-toastify";
import DayPlan from "../../customComponents/DayPlan";
import TextEditor from "../../customComponents/TextEditor";
import DatePicker from "../../customComponents/DatePicker";
import SignatureCanvas from "react-signature-canvas";
import React, { useRef } from "react";
import { MultiNewSelect } from "../../customComponents/NewMultiSelect";
import PackageUpload from "../../customComponents/PackageUpload";
import SearchSelect from "../../customComponents/SerachSelect";
import { getHotelPricesWithDays } from "../../utils/helper";
import { generateItineraryPDF } from "../pdfGenerator";
import { slugify } from "../../utils/slugify";

const AddItinerary = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [days, setDays] = useState([]);
  const [isFirstDayAdded, setIsFirstDayAdded] = useState(false);
  const [selectedValue, setSelectedValue] = useState("single");
  const [formData, setFormData] = useState({});
  const [selectedOption, setSelectedOption] = useState(null);
  const [showSeasonalFields, setShowSeasonalFields] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedItineraryDate, setItineraryDate] = useState(new Date());
  const [selectedRepresentDate, setRepresentDate] = useState(new Date());

  const [selectedPackageType, setSelectedPackageType] = useState(null);
  const sigCanvas = useRef(null);

  const [packageOptions, setPackagOptions] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [dropdownDataLoaded, setDropdownDataLoaded] = useState(false);
  const [enquiryOptions, setEnquiryOptions] = useState([]);
  const [selectedEnquiry, setSelectedEnquiry] = useState(null);
  const [schoolOptions, setSchoolOptions] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [isDeclarationChecked, setIsDeclarationChecked] = useState(false);

  const [packageTypeOptions, setPackageTypeOptions] = useState([]);
  const [hotelTypeOptions, setHotelTypeOptions] = useState([]);
  const [onwardTransportOptions, setOnwardTransportOptions] = useState([]);
  const [returnTransportOptions, setReturnTransportOptions] = useState([]);
  const [transferOptions, setTransferOptions] = useState([]);
  const [addonOptions, setAddonOptions] = useState([]);
  const [hotelNameOptions, setHotelNameOptions] = useState([]);

  const [selectedHotel, setSelectedHotel] = useState(null);
  const [selectedHotelMealPlan, setSelectedHotelMealPlan] = useState("");
  const [selectedOnwardTransport, setSelectedOnwardTransport] = useState(null);
  const [selectedReturnTransport, setSelectedReturnTransport] = useState(null);
  const [selectedTransfers, setSelectedTransfers] = useState(null);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [extraBFCount, setExtraBFCount] = useState("");
  const [extraLunchCount, setExtraLunchCount] = useState("");
  const [extraDinnerCount, setExtraDinnerCount] = useState("");
  const [addOnsAmount, setAddOnsAmount] = useState("");
  const [deviationAmount, setDeviationAmount] = useState("");
  const [totalPrice, setTotalPrice] = useState("");
  const [numberOfPax, setNumberOfPax] = useState("");
  const [showExtraBF, setShowExtraBF] = useState(false);
  const [showExtraLunch, setShowExtraLunch] = useState(false);
  const [showExtraDinner, setShowExtraDinner] = useState(false);
  const [isRender, setRender] = useState(false);
  const [paidAdults, setPaidAdults] = useState(0);
  const [focValue, setFocValue] = useState("");
  const [selectedFOC, setSelectedFOC] = useState(0);
  const [settingsGSTValue, setSettingsGSTValue] = useState("");
  const [settingsMarkupValue, setSettingsMarkupValue] = useState("");
  const [studentWeekdayTotal, setStudentWeekdayTotal] = useState(0);
  const [studentWeekendTotal, setStudentWeekendTotal] = useState(0);
  const [adultWeekDayTotal, setAdultWeekDayTotal] = useState(0);
  const [adultWeekendTotal, setAdultWeekendTotal] = useState(0);
  const [hotelPrice, setHotelPrice] = useState(0);
  const [addOnsPrice, setAddOnsPrice] = useState(0);
  const [accommodationValue, selectedAccommodation] = useState("");
  const [editData, setEditData] = useState({});
  const [freshItinerary, setFreshItinerary] = useState(null);
  const [pricePerFOC, setPricePerFOC] = useState(1000);
  const [transportationSelections, setTransportationSelections] = useState([
    { selectedOnwardTransport: null, busCount: 1 },
  ]);
  const [allHotelNames, setAllHotelNames] = useState([]);
  const [dayOptions, setDayOptions] = useState([]);

  useEffect(() => {
    if (Array.isArray(editData?.transportationSelections)) {
      const hydrated = editData.transportationSelections.map((item) => ({
        selectedOnwardTransport: item?.selectedOnwardTransport ?? null,
        busCount: item?.busCount ?? 1,
      }));

      setTransportationSelections(hydrated);
    }
  }, [editData]);
  const [transferSelections, setTransferSelections] = useState([
    { selectedTransfers: null, busCount: 1 },
  ]);
  const [tourManager, setTourManager] = useState(false);

  const [tourManagerCount, setTourManagerCount] = useState(0);
  const [hotelSelections, setHotelSelections] = useState([
    {
      hotelType: null,
      hotelName: null,
      mealPlan: null,
      day: null,
      noofRooms: 0,
    },
  ]);

  const [allGSTValues, setAllGSTValues] = useState({
    student: {
      weekdays: 0,
      weekends: 0,
      offSeason: 0,
      peakSeason: 0,
    },
    adult: {
      weekdays: 0,
      weekends: 0,
    },
  });

  const [onWardTrnPrice, setOnWardTrnPrice] = useState(0);
  const [returnTrnPrice, setReturnTrnPrice] = useState(0);
  const [transfersPrice, setTransfersPrice] = useState(0);
  const [isPriceModalOpen, setIsPriceModalOpen] = useState(false);

  const [markupAmount, setMarkupAmount] = useState(0);
  const [gstAmount, setGstAmount] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDayouting, setIsDayouting] = useState(false);
  const [isDayvisit, setIsDayvisit] = useState(false);
  const [isDomestic, setIsDomestic] = useState(false);
  const [isDomesticDMC, setIsDomesticDMC] = useState(false);
  const [isInternational, setIsInternational] = useState(false);
  const [peakSeasonPrice, setPeakSeasonPrice] = useState(0);
  const [offSeasonPrice, setOffSeasonPrice] = useState(0);
  const [selectedHotelName, setSelectedHotelName] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [hotelType, setHotelType] = useState("");
  const [reducedMarkup, setReducedMarkup] = useState(0);
  const [returnReducedMarkup, setReturnReducedMarkup] = useState(0);
  const [editorContents, setEditorContents] = useState({
    transportation_details: "",
    hotel_details: "",
    meal_plan: "",
    inclusions: "",
    exclusions: "",
    terms_conditions: "",
    learning_outcomes: "",
    payment_plan: "",
    cancellation_policy: "",
    notes: "",
  });

  const [formValues, setFormValues] = useState({
    packagetypeid: null,
    packagename: "",
    city: "",
    destination: "",
    noofdays: "",
    noofnights: "",
    hoteltypeid: null,
    onwardtrnid: null,
    returnid: null,
    transferid: null,
    addonid: null,
    extra_bfcount: 0,
    extra_lunchcount: 0,
    extra_dinnercount: 0,
    noofpax: 0,
    foc: "",
    addon_amount: 0,
    deviation_amount: 0,
    price_perhead: 0,
    daywise_plan: [],
    package_image: null,
    currency: "INR",
    total_amount: 0,
    description: "",
    trip_image: "",
  });

  const fetchAllOptions = async () => {
    try {
      await Promise.all([
        fetchPackages(),
        fetchSchools(),
        fetchEnquirys(),
        getSettings(),
        fetchPackageTypes(),
        fetchHotelTypes(),
        fetchOnwardTransport(),
        fetchAddons(),
      ]);
      setDropdownDataLoaded(true); // Mark options as loaded
    } catch (error) {
      console.error("Error fetching dropdown options:", error);
    }
  };

  useEffect(() => {
    fetchAllOptions();
  }, [isDomestic]);
  const handleAddDayField = () => {
    setHotelSelections([
      ...hotelSelections,
      { hotelType: null, mealPlan: null, day: null },
    ]);
    setSelectedHotelName(null);
  };
  const handleDeleteDayField = (index) => {
    const updatedSelections = hotelSelections.filter((_, i) => i !== index);
    setHotelSelections(updatedSelections);
  };
  const fetchHotelNames = async (name) => {
    try {
      const payload = { type: "hotelname_hoteltype" };
      const result = await post("/getOptionList", payload);
      // console.log('name   ............>>>>', name);
      const filteredoptions = result.data.filter(
        (item) => item.hoteltype?.toLowerCase() === name?.toLowerCase()
      );
      setHotelNameOptions(filteredoptions);
    } catch (error) {
      console.error("Error fetching hotel types:", error);
    }
  };
  useEffect(() => {
    fetchHotelNames(selectedType?.hoteltype);
  }, [selectedType?.hoteltype]);
  const handleHotelChanges = async (selectedOption, index, field) => {
    const updatedSelections = [...hotelSelections];
    // console.log("updatedSelections", selectedOption);
    if (field === "hotelType") {
      setSelectedType(selectedOption);
      // if (index == 0) {
      setHotelType({
        label: selectedOption.hoteltype,
        value: selectedOption.hoteltypeid,
        // hoteltype: selectedOption.hoteltype,
      });
      // }
      // const mealOptions = await fetchHotelMealPlan(selectedOption.id);

      updatedSelections[index] = {
        ...updatedSelections[index],
        hotelType: selectedOption,
        // options: mealOptions,
        // mealPlan: null,
      };
    } else if (field === "hotelName") {
      // if (index == 0) {
      setSelectedHotelName({
        label: selectedOption.label,
        value: selectedOption.hoteltypeid,
        // hoteltype: selectedOption.hoteltype,
      });
      // }
      const mealOptions = await fetchHotelMealPlan(selectedOption.id);

      updatedSelections[index] = {
        ...updatedSelections[index],
        hotelName: selectedOption,
        options: mealOptions,
        mealPlan: null,
      };
    } else if (field === "mealPlan") {
      if (index == 0) {
        selectedAccommodation(selectedOption);
      }
      setStudentWeekdayTotal(0);
      setStudentWeekendTotal(0);
      setAdultWeekDayTotal(0);
      setAdultWeekendTotal(0);
      updatedSelections[index] = {
        ...updatedSelections[index],
        mealPlan: selectedOption,
      };
    } else if (field === "day") {
      // console.log(selectedOption, "day value ====>>>>");
      updatedSelections[index] = {
        ...updatedSelections[index],
        day: selectedOption,
      };
    } else if (field === "rooms") {
      // console.log(selectedOption, "day value ====>>>>");
      updatedSelections[index] = {
        ...updatedSelections[index],
        noofRooms: selectedOption,
      };
    }
    setSelectedHotel(updatedSelections[0]?.hotelType);
    setHotelSelections(updatedSelections);
  };
  const fetchHotelMealPlan = async (id) => {
    try {
      const payload = {
        type: "hotelname_hotelwiseplan",
        hotelid: id,
        hoteltype:
          selectedPackageType?.label === "Domestic" ? "seasontype" : "others",
      };
      const result = await post("/getOptionList", payload);
      // console.log(result.data, "result.data meal plan");
      return result.data;
    } catch (error) {
      console.error("Error fetching hotel meal plans:", error);
      return [];
    }
  };

  const handleOpenPriceModal = () => {
    setIsPriceModalOpen(true);
  };

  const handleClosePriceModal = () => {
    setIsPriceModalOpen(false);
  };

  const focHandler = (val, _paxCount) => {
    // FOC loading disabled — cost is recovered via seat/room allocation at booking time
    // if (!_paxCount || _paxCount === 0) return val;
    // const focModifiedValue = val * ((_paxCount + selectedFOC) / _paxCount);
    // return Math.round(focModifiedValue);
    return Math.round(val);
  };

  useEffect(() => {
    if (!selectedFOC) return;
    focHandler();
  }, [selectedFOC]);

  const [returnSelections, setReturnSelections] = useState([
    { selectedReturnTransport: null, busCount: 1 },
  ]);

  const [allMarkups, setAllMarkups] = useState({
    student: {
      weekdays: 0,
      weekends: 0,
      offSeason: 0,
      peakSeason: 0,
    },
    adult: {
      weekdays: 0,
      weekends: 0,
    },
  });
  const location = useLocation();
  const navigate = useNavigate();
  const { itineraryData } = location.state || {};
  const isEdit = location.state?.isEdit;

  useEffect(() => {
    if (isEdit && dropdownDataLoaded) {
      // Re-fetch the latest itinerary by id; the nav-state snapshot only
      // carries the id and page. fetchItineraryInfo chains the fresh package
      // fetch and the signature prepopulation off the fresh row.
      fetchItineraryInfo(itineraryData?.itinerarydetailsid);
    }
  }, [dropdownDataLoaded]);

  const fetchPackages = async () => {
    try {
      const payload = { type: "packages", isitenary: true };
      const result = await post("/getOptionList", payload);
      setPackagOptions(result.data);
    } catch (error) {
      console.error("Error fetching package types:", error);
    }
  };

  const fetchSchools = async () => {
    try {
      const payload = { type: "institution" };
      const result = await post("/getOptionList", payload);
      const options = result.data.map((item) => ({
        value: item.id,
        label: item.label,
        id: item.id,
      }));

      setSchoolOptions(options);
    } catch (error) {
      console.error("Error fetching package types:", error);
    }
  };
  const getSettings = async () => {
    try {
      const req = {};
      const response = await post("/getSettings", req);
      // setSettings(response.data);
      // Map the settings to the respective fields
      response.data?.forEach((setting) => {
        if (setting.settingsid === 1) {
          setSettingsMarkupValue(setting.settingsvalue);
        } else if (setting.settingsid === 2) {
          setSettingsGSTValue(setting.settingsvalue);
        }
      });
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };
  const fetchEnquirys = async () => {
    try {
      const payload = { type: "enquirys" };
      const result = await post("/getOptionList", payload);
      setEnquiryOptions(result.data);
    } catch (error) {
      console.error("Error fetching package types:", error);
    }
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleItineraryDateChange = (date) => {
    const now = new Date();
    const exactDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      now.getHours(),
      now.getMinutes(),
      now.getSeconds()
    );
    setItineraryDate(exactDate);
  };

  const handleRepresentDateChange = (date) => {
    setRepresentDate(date);
  };

  // console.log("first", location);
  const handleAddDay = useCallback(() => {
    setIsFirstDayAdded(true);
    setDays((prevDays) => {
      const newDayNumber = prevDays.length + 1;
      return [
        ...prevDays,
        { dayNumber: newDayNumber, timeSlots: [], planName: "" },
      ];
    });
  }, []);

  const handleNavigateBack = () => {
    navigate(location.state?.page ? `/all-itinerary?page=${location.state.page}` : "/all-itinerary");
  };

  const handleUploadSelect = (file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setFormData({ ...formData, logo: reader.result });
    };
    reader.onerror = (error) => {
      console.error("Error converting file to Base64:", error);
    };
  };

  const validateFile = (file) => {
    if (!file.type.startsWith("image/")) {
      return "Only image files are allowed.";
    }
    if (file.size > 3 * 1024) {
      return "File size should not exceed 300kb.";
    }
    return null;
  };
  const options = [
    { value: "10:1", label: "10:1" },
    { value: "15:1", label: "15:1" },
    { value: "20:1", label: "20:1" },
    { value: "30:1", label: "30:1" },
    { value: "40:1", label: "40:1" },
  ];

  const handleChange = (option) => {
    setSelectedOption(option);
    if (numberOfPax) {
      const focRatio = parseInt(option?.value?.split(":")[0]);
      const focCount = parseInt(numberOfPax / focRatio);

      setSelectedFOC(isNaN(focCount) ? 0 : focCount);
    } else {
      toast.error("Please enter number of pax");
    }
  };

  const handlePackageTypeChange = (option) => {
    // console.log('option',option)
    setSelectedPackageType(option);
    setFormValues((prev) => ({ ...prev, packagetypeid: option.value }));

    // Check if Day outing is selected
    const isDayoutingSelected = option.label === "Day outing";
    setIsDayouting(isDayoutingSelected);

    // Check if Day Visit - Local sightseeing is selected
    const isDayvisitSelected = option.label?.includes("Day Visit");
    setIsDayvisit(isDayvisitSelected);

    // Check if Domestic is selected
    const isDomesticSelected = option.label === "Domestic";
    setIsDomestic(isDomesticSelected);

    const isDomesticDMCSelected = option.label === "Domestic - DMC";
    setIsDomesticDMC(isDomesticDMCSelected);
    // Check if International is selected
    const isInternationalSelected = option.label === "International";
    setIsInternational(isInternationalSelected);

    // Reset hotel and meal plan if Day outing is selected
    if (isDayoutingSelected) {
      setSelectedHotel(null);
      setSelectedHotelMealPlan(null);
    }
  };

  const filterTransferOptions = (options, packageType) => {
    if (!options) return [];

    const lowerType = packageType?.toLowerCase();

    if (lowerType === "international") {
      return options?.filter((opt) =>
        opt.label.toLowerCase().includes("flight")
      );
    }

    if (lowerType === "day outing" || lowerType === "day visit") {
      return options.filter(
        (opt) =>
          !opt.label.toLowerCase().includes("train") &&
          !opt.label.toLowerCase().includes("flight")
      );
    }

    return options; // for domestic and others
  };

  // UI Handlers
  const handleAddTransField = () => {
    setTransportationSelections((prev) => [
      ...prev,
      {
        selectedOnwardTransport: null,
        busCount: 1,
      },
    ]);
  };

  const extraItems = [
    {
      show: showExtraBF,
      label: "Extra BF Count",
      value: extraBFCount,
      setter: setExtraBFCount,
    },
    {
      show: showExtraLunch,
      label: "Extra Lunch Count",
      value: extraLunchCount,
      setter: setExtraLunchCount,
    },
    {
      show: showExtraDinner,
      label: "Extra Dinner Count",
      value: extraDinnerCount,
      setter: setExtraDinnerCount,
    },
    {
      show: tourManager,
      label: "Tour Manager Count",
      value: tourManagerCount,
      setter: setTourManagerCount,
    },
  ];
  // Clear the signature canvas when the "Clear" button is clicked
  const clearSignature = () => {
    if (sigCanvas.current) {
      sigCanvas.current.clear();
    }
  };
  const validateFields = () => {
    console.log("iti--->>>>>>", formData, selectedPackage);
    if (!formData?.itineraryName?.length) {
      toast.error("Itinerary name is required");
      return false;
    }
    if (!selectedPackage?.id) {
      toast.error("Please select a package");
      return false;
    }

    if (!selectedItineraryDate) {
      toast.error("Date of travel is required");
      return false;
    }

    if (!selectedEnquiry?.id) {
      toast.error("Please select an enquiry");
      return false;
    }

    if (!selectedSchool?.id) {
      toast.error("Please select a school");
      return false;
    }
    // Only validate representative fields if checkbox is checked
    if (isDeclarationChecked) {
      if (!formValues.representative?.trim()) {
        toast.error("Representative name is required");
        return false;
      }

      if (!formValues.school?.trim()) {
        toast.error("School name is required");
        return false;
      }

      if (!selectedRepresentDate) {
        toast.error("Representative date is required");
        return false;
      }
    }
    // if (!selectedPackageType?.id) {
    //   toast.error("Package type is required");
    //   return false;
    // }

    if (!formValues.packagename?.trim()) {
      toast.error("Package name is required");
      return false;
    }

    if (!formValues.city?.trim()) {
      toast.error("Source city is required");
      return false;
    }

    if (!formValues.destination?.trim()) {
      toast.error("Destination is required");
      return false;
    }
    if (!isDayouting && !isDayvisit) {
      const noofdays = Number(formValues.noofdays);
      const noofnights = Number(formValues.noofnights);
      if (!noofdays || noofdays <= 0) {
        toast.error("Number of days must be greater than 0");
        return false;
      }

      if (!noofnights || noofnights <= 0) {
        toast.error("Number of nights must be greater than 0");
        return false;
      }
    }

    if (!isDomesticDMC && !isDayvisit && !isInternational && !isDayouting) {
      hotelSelections?.forEach((field, index) => {
        if (!field?.hotelType?.value) {
          // throw new Error(
          //   `Hotel Type is required for plan ${index + 1}.`
          // );
          toast.error(`Hotel Type is required for plan ${index + 1}.`);
          return false;
        }
        if (!field?.mealPlan?.label) {
          toast.error(`Meal Plan is required for plan ${index + 1}.`);
          return false;
        }
        if (field?.day?.length == 0) {
          toast.error(`Day is required for plan ${index + 1}.`);
          return false;
        }
      });
    }

    if (!transportationSelections[0]?.selectedOnwardTransport?.id) {
      toast.error("Please select onward transportation");
      return false;
    }

    if (
      Array.isArray(returnSelections) &&
      returnSelections.length > 0 &&
      returnSelections[0]?.selectedReturnTransport != null &&
      !returnSelections[0]?.selectedReturnTransport?.id &&
      selectedPackageType?.label === "International"
    ) {
      toast.error("Please select return transportation");
      return false;
    }

    if (!numberOfPax || numberOfPax <= 0) {
      toast.error("Number of pax must be greater than 0");
      return false;
    }

    if (!days.length) {
      toast.error("At least one day plan is required");
      return false;
    }

    for (const day of days) {
      if (!day.planName?.trim()) {
        toast.error(`Plan name for Day ${day.dayNumber} is required`);
        return false;
      }
      if (!day.timeSlots?.length) {
        toast.error(`Time slots for Day ${day.dayNumber} are required`);
        return false;
      }
    }

    // if (!formValues.representative?.trim()) {
    //   toast.error("Representative name is required");
    //   return false;
    // }

    // if (!formValues.school?.trim()) {
    //   toast.error("School name is required");
    //   return false;
    // }

    // if (!selectedRepresentDate) {
    //   toast.error("Representative date is required");
    //   return false;
    // }

    return true;
  };

  const calculateHotelRoomPrice = (hotelSelections, noofpax) => {
    let offSeasonTotal = 0;
    let peakSeasonTotal = 0;

    hotelSelections?.forEach((item) => {
      const noOfRooms = parseInt(item.noofRooms) || 0;
      const days = item.day?.length || 0;

      // Use ONLY the selected mealPlan instead of all options
      const selectedOption = item.mealPlan;
      if (!selectedOption) return;

      const label = selectedOption.label?.toLowerCase() || "";
      const pph = parseFloat(selectedOption.pph) || 0;

      // Sharing type just to check how many people per room
      const typeOfSharing = (label) => {
        if (label.includes("single")) return 1;
        if (label.includes("double")) return 2;
        if (label.includes("triple")) return 3;
        if (label.includes("quad") || label.includes("quard")) return 4;
        return 1;
      };

      const multiplier = typeOfSharing(label);

      // ✅ Correct formula: per-person × rooms × sharing × days
      const total = pph * noOfRooms * multiplier * days;

      if (label.includes("off-season")) {
        offSeasonTotal += total;
      }
      if (label.includes("peak season")) {
        peakSeasonTotal += total;
      }
    });

    if (noofpax > 0) {
      offSeasonTotal /= noofpax;
      peakSeasonTotal /= noofpax;
    }

    return {
      offSeason: offSeasonTotal,
      peakSeason: peakSeasonTotal,
    };
  };
  // console.log('check ',selectedPackageType,formData,formValues)
  const handleSavePackage = async () => {
    if (!validateFields()) {
      return;
    }
    try {
      const formattedDays = days.map((day) => ({
        dayNumber: day.dayNumber,
        timeSlots: day.timeSlots || [],
        planName: day.planName,
        daywiseImage: day.daywiseImage,
      }));
      const signatureData = getSignatureData();

      const addonIds = Array.isArray(selectedAddons)
        ? `{${selectedAddons.map((addon) => addon.id).join(",")}}`
        : selectedAddons?.id
          ? `{${selectedAddons.id}}`
          : null;

      let hotelPlan = [];

      hotelSelections?.forEach((field, index) => {
        hotelPlan.push({
          hotelType: field?.hotelType?.value,
          mealPlan: field?.mealPlan?.value,
          day: Array.isArray(field.day)
            ? `{${field.day.map((addon) => addon.value).join(",")}}`
            : field.day?.value
              ? `{${field.day.value}}`
              : null,
        });
      });
      let accomdaTion;

      const basePayload = {
        // Common fields
        packagetypeid: selectedPackageType?.value,
        packagetype: selectedPackageType?.label,
        packagename: formValues?.packagename,
        cityid: formValues?.city,
        destination: formValues?.destination,
        noofdays: Number(formValues?.noofdays),
        noofnights: Number(formValues?.noofnights),
        hoteltypeid: selectedHotel?.id,
        onwardtrnid: selectedOnwardTransport?.id,
        returnid: selectedReturnTransport?.id,
        transferid: selectedTransfers?.id,
        addonid: addonIds,
        extra_bfcount: Number(extraBFCount),
        extra_lunchcount: Number(extraLunchCount),
        extra_dinnercount: Number(extraDinnerCount),
        extra_TMCount: Number(tourManagerCount), // ✅ added from packages
        noofpax: Number(numberOfPax),
        foc: selectedOption?.value,
        focCount: selectedFOC, // ✅ added
        adult_count: Number(paidAdults || 0), // ✅ added
        addon_amount: parseInt(addOnsAmount, 10),
        deviation_amount: Number(deviationAmount),

        // Pricing logic — itinerary might use simple price, but we include packages logic
        price_perhead: focHandler
          ? focHandler(
            Math.round(
              selectedPackageType?.label === "Domestic"
                ? offSeasonPrice > 0
                  ? offSeasonPrice +
                  onWardTrnPrice +
                  returnTrnPrice +
                  transfersPrice +
                  addOnsAmount +
                  deviationAmount +
                  (typeof allMarkups?.student?.offSeason === "number"
                    ? allMarkups.student.offSeason
                    : markupAmount) +
                  (typeof allGSTValues?.student?.offSeason === "number"
                    ? allGSTValues.student.offSeason
                    : gstAmount)
                  : peakSeasonPrice > 0
                    ? peakSeasonPrice +
                    onWardTrnPrice +
                    returnTrnPrice +
                    transfersPrice +
                    addOnsAmount +
                    deviationAmount +
                    (typeof allMarkups?.student?.peakSeason === "number"
                      ? allMarkups.student.peakSeason
                      : markupAmount) +
                    (typeof allGSTValues?.student?.peakSeason === "number"
                      ? allGSTValues.student.peakSeason
                      : gstAmount)
                    : 0
                : typeof totalAmountStudentWeekDays === "number" &&
                  totalAmountStudentWeekDays > 0
                  ? totalAmountStudentWeekDays +
                  (allMarkups?.student?.weekdays || 0) +
                  (allGSTValues?.student?.weekdays || 0)
                  : typeof totalAmountAdultWeekdays === "number" &&
                    totalAmountAdultWeekdays > 0
                    ? totalAmountAdultWeekdays +
                    (allMarkups?.adult?.weekdays || 0) +
                    (allGSTValues?.adult?.weekdays || 0)
                    : 0
            ),
            numberOfPax
          )
          : Number(totalPrice), // fallback for itinerary

        daywise_plan: formattedDays,
        package_image: formData?.logo || "",
        currency: "INR",
        total_amount: Number(totalPrice * numberOfPax),
        type: location.state?.isEdit ? "update" : "insert",
        texteditorData: editorContents,
        city: formValues?.city,
        dateoftravel: selectedDate,
        isAudit: true, // ✅ added
        user: user?.username || "N/A",
        isitinerary: true, // itinerary marker

        // Hotel plan + selections
        hotel_mealplan:
          typeof selectedHotelMealPlan === "string"
            ? selectedHotelMealPlan
            : selectedHotelMealPlan?.value,
        packagewise_plan: hotelSelections,

        // Transport selections
        transportation: JSON.stringify(
          transportationSelections?.map(
            ({ selectedOnwardTransport, busCount }) => ({
              selectedOnwardTransport,
              busCount,
            })
          )
        ),
        return_transportation: JSON.stringify(
          returnSelections?.map(({ selectedReturnTransport, busCount }) => ({
            selectedReturnTransport,
            busCount,
          }))
        ),
        transfer_transportation: JSON.stringify(
          transferSelections?.map(({ selectedTransfers, busCount }) => ({
            selectedTransfers,
            busCount,
          }))
        ),

        // Itinerary-specific
        itinerary_sign: signatureData,
        itineraryname: formData?.itineraryName?.replace(/draft/i, "").trim().replace(/\s+/g, " "),
        itinerary_travel: selectedItineraryDate,
        enquiryid: selectedEnquiry?.id,
        representative_name: formValues?.representative,
        schoolname: selectedSchool?.label,
        representative_date: selectedRepresentDate,
        packagedetailsid: selectedPackage?.id,
        institutionid: selectedSchool?.id,
        isPackageType: "update",
        trip_image: formValues?.trip_image || "",
        description: formValues?.description || "",
      };

      const payload = location.state?.isEdit
        ? {
          ...basePayload,
          itinerarydetailsid:
            location.state?.itineraryData?.itinerarydetailsid,
        }
        : basePayload;
      const result = await post("/getOptionList", payload);
      if (result.data.length > 0) {
        accomdaTion = result.data.filter(
          (list) => list.label == accommodationValue
        );
      }

      // console.log('payload', payload);
      // return
      const response = await post("/addItinerary", payload);

      if (response.status) {
        toast.success("Itinerary added successfully!");
        navigate(location.state?.page ? `/all-itinerary?page=${location.state.page}` : "/all-itinerary");
      }
    } catch (error) {
      toast.error("Failed to save package: " + error.message);
    }
  };

  const handleItineraryNameChange = (e) => {
    setFormData({
      ...formData,
      itineraryName: e.target.value,
    });
  };

  const handleFormSelection = (e, type) => {
    if (type == "packages") {
      const selected = packageOptions.find((item) => item.id === e.value);
      setSelectedPackage(selected);
      fetchPackagesInfo(e.value);
    } else if (type == "schools") {
      const selected = schoolOptions.find((item) => item.id === e.value);
      setSelectedSchool(selected);
    } else {
      const selected = enquiryOptions.find((item) => item.id === e.value);
      setSelectedEnquiry(selected);
    }
  };

  const generateMarkupAndGST = (basePrice) => {
    let finalPrice = basePrice;

    const markupAmount =
      Number(settingsMarkupValue) > 0
        ? ((basePrice - (reducedMarkup + returnReducedMarkup)) *
          Number(settingsMarkupValue)) /
        100
        : 0;
    finalPrice += markupAmount;

    const gstAmount =
      Number(settingsGSTValue) > 0
        ? ((finalPrice - (reducedMarkup + returnReducedMarkup)) *
          Number(settingsGSTValue)) /
        100
        : 0;
    finalPrice += gstAmount;

    return {
      finalPrice: Math.round(finalPrice),
      markupAmount: Math.round(markupAmount),
      gstAmount: Math.round(gstAmount),
    };
  };
  const isInSeason = (startDate, endDate) => {
    if (!startDate || !endDate || !selectedDate) return false;
    const currentDate = new Date(selectedDate);
    const seasonStart = new Date(startDate);
    const seasonEnd = new Date(endDate);
    return currentDate >= seasonStart && currentDate <= seasonEnd;
  };
  const getHotalPricePrice = (item) => {
    let totalHotelPrice = 0;
    for (let i = 0; i < item?.length; i++) {
      let selectedhotelType = item[i]?.hotelType;
      let selecteMealPlan = item[i]?.mealPlan;
      let selecteDays = item[i]?.day;
      let number_of_days = selecteDays?.length || 1;

      if (!showSeasonalFields || !selectedhotelType) {
        totalHotelPrice += Number(number_of_days * selectedhotelType?.pph || 0);
      } else if (
        isInSeason(
          selectedhotelType?.seasonstart,
          selectedhotelType?.seasonend
        ) &&
        selectedhotelType?.sph
      ) {
        totalHotelPrice += Number(number_of_days * selectedhotelType?.sph);
      } else {
        totalHotelPrice += Number(number_of_days * selecteMealPlan?.pph || 0);
      }
    }

    return totalHotelPrice;
  };

  const fetchItineraryInfo = async (id) => {
    if (!id) {
      toast.error("Missing itinerary id");
      return;
    }
    try {
      const result = await post("/getAllItinerary", { itinerarydetailsid: id });
      const fresh = result?.data?.[0];
      if (!fresh) {
        toast.error("Failed to load latest itinerary data");
        return;
      }
      // The list derives a camelCase `itineraryName` ("<name> Draft") onto the
      // snapshot; the raw DB row only has `itineraryname` + `isdraft`. Rebuild
      // it so downstream hydration (which reads `itineraryName`) works unchanged.
      const normalized = {
        ...fresh,
        itineraryName: `${fresh.itineraryname} ${fresh.isdraft ? "Draft" : ""}`,
      };
      setFreshItinerary(normalized);
      fetchPackagesInfo(normalized.packagedetailsid, normalized);

      if (normalized.itinerary_sign) {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.src = normalized.itinerary_sign;
        img.onload = () => {
          if (sigCanvas.current) {
            const ctx = sigCanvas.current.getCanvas().getContext("2d");
            ctx.drawImage(img, 0, 0);
          }
        };
      }
    } catch (error) {
      console.error("Error fetching itinerary:", error);
      toast.error("Failed to load latest itinerary data");
    }
  };

  const fetchPackagesInfo = async (id, itinerary) => {
    try {
      const payload = { packagedetailsid: id, isitenary: true };
      const result = await post("/getAllPackages", payload);

      prePopulateValue(result.data?.[0], itinerary);
    } catch (error) {
      console.error("Error fetching hotel types:", error);
    }
  };

  const prePopulateValue = async (data, itinerary) => {
    try {
      let packageData = data ? data : "";
      const itineraryData = itinerary ?? {};
      // console.log('pa',packageData)
      // setFormData({
      //   ...formData,
      //   logo: packageData?.package_image || null,
      // });
      setShowSeasonalFields(packageData?.seasonal || false);
      setSelectedPackageType({
        label: packageData?.packagetype,
        value: packageData?.packpackagetypeid,
        id: packageData?.packagetypeid,
      });
      setIsDayouting(packageData?.packagetype === "Day outing");
      setIsDayvisit(
        packageData.packagetype === "Day Visit - Local sightseeing"
      );
      setIsDomestic(packageData.packagetype === "Domestic");
      setIsDomesticDMC(packageData.packagetype === "Domestic - DMC");
      setIsInternational(packageData.packagetype === "International");
      setFormValues({
        packagetypeid: packageData?.packagetypeid,
        packagename: packageData.packagename,
        city: packageData.city,
        destination: packageData.destination,
        noofdays: packageData.noofdays,
        noofnights: packageData.noofnights,
        representative: itineraryData?.representative_name,
        school: itineraryData?.schoolname,
      });
      const hotelType = hotelTypeOptions.find(
        (hotel) => hotel?.id === parseInt(packageData?.hoteltypeid)
      );
      setIsDeclarationChecked(!!itineraryData?.representative_name);
      handlePackageTypeChange({
        label: packageData?.packagetype,
        value: packageData?.packagetypeid,
      });
      setTransportationSelections(packageData?.transportation);
      setReturnSelections(
        transportationSelections?.some(
          (item) =>
            item?.selectedOnwardTransport?.vehicaltype.toLowerCase() !== "bus"
        )
          ? packageData?.return_transportation
          : [{ selectedReturnTransport: null }]
      );
      setTransferSelections(packageData?.transfer_transportation || []);
      setHotelSelections(packageData?.packagewise_plan || []);
      // console.log('hotelType', packageData);
      setSelectedType(packageData?.packagewise_plan[0]?.hotelType || null);

      const onWardTrn = onwardTransportOptions.find(
        (list) => list?.id === parseInt(packageData?.onwardtrnid)
      );
      const returnWardTrn = onwardTransportOptions.find(
        (list) => list?.id === parseInt(packageData?.returnid)
      );
      const transfers = onwardTransportOptions.find(
        (list) => list?.id === parseInt(packageData?.transferid)
      );
      // const addons = addonOptions.find(
      //   (list) => list?.id === parseInt(packageData?.addonid)
      // );

      const addons = addonOptions.filter((list) =>
        packageData?.addonid?.includes(list?.id?.toString())
      );

      const foc = options.find((list) => list?.value === packageData?.foc);
      // console.log("packageData", packageData);
      setSelectedOnwardTransport(onWardTrn);
      setSelectedReturnTransport(returnWardTrn);
      setSelectedTransfers(transfers);
      setSelectedHotel(hotelType);
      setSelectedAddons(addons);
      setShowExtraBF(
        Array.isArray(addons) &&
        addons.some(
          (addon) =>
            addon.label === "Extra Breakfast" ||
            addon.label.includes("Extra Breakfast")
        )
      );
      setShowExtraLunch(
        Array.isArray(addons) &&
        addons.some((addon) => addon.label.includes("Extra Lunch"))
      );
      setShowExtraDinner(
        Array.isArray(addons) &&
        addons.some((addon) => addon.label.includes("Extra Dinner"))
      );
      setTourManager(
        Array.isArray(addons) &&
        addons.some((addon) => addon.label.includes("Tour manager"))
      );
      setExtraBFCount(Number(packageData.extra_bfcount) || 0);
      setExtraDinnerCount(Number(packageData.extra_dinnercount) || 0);
      setExtraLunchCount(Number(packageData.extra_lunchcount) || 0);
      setTourManagerCount(Number(packageData.extra_tm_count) || 0);
      setNumberOfPax(Number(packageData?.noofpax));
      setSelectedOption({ label: packageData?.foc, value: packageData?.foc });
      const focRatio = parseInt(packageData?.foc?.split(":")[0]);
      const focCount = parseInt(Number(packageData?.noofpax) / focRatio);
      setPaidAdults(packageData?.adult_count || 0);
      setSelectedFOC(focCount ? Number(focCount) : 0);
      setAddOnsAmount(Math.round(Number(packageData?.addon_amount) || 0));
      setDeviationAmount(Number(packageData?.deviation_amount));
      setEditorContents({
        transportation_details:
          packageData?.texteditordata?.transportation_details,
        hotel_details: packageData?.texteditordata?.hotel_details,
        meal_plan: packageData?.texteditordata?.meal_plan,
        inclusions: packageData?.texteditordata?.inclusions,
        exclusions: packageData?.texteditordata?.exclusions,
        terms_conditions: packageData?.texteditordata?.terms_conditions,
        learning_outcomes: packageData?.texteditordata?.learning_outcomes,
        payment_plan: packageData?.texteditordata?.payment_plan || "",
        cancellation_policy: packageData?.texteditordata?.cancellation_policy || "",
        notes: packageData?.texteditordata?.notes || "",
      });
      setSelectedDate(new Date(packageData?.dateoftravel));
      let isSeason = packageData?.dateoftravel ? true : false;
      setShowSeasonalFields(isSeason);

      setIsFirstDayAdded(true);
      const fetchedDays = packageData?.daywise_plan || [];
      setDays(fetchedDays.map(d => ({
        ...d,
        timeSlots: (d.timeSlots || []).map(s => ({ ...s, _id: s._id || `db-${Math.random().toString(36).substr(2, 9)}` }))
      })));
      setFormData({
        ...formData,
        logo: packageData?.package_image ? packageData?.package_image : null,
      });
      //  setFormData(packageData?.package_image);
      // setDays(packageData?.daywise_plan)
      // if (packageData?.signature && sigCanvas.current) {
      //   const img = new Image();
      //   img.onload = () => {
      //     const ctx = sigCanvas.current.getCanvas().getContext("2d");
      //     ctx.drawImage(img, 0, 0);
      //   };
      //   img.src = data.signature;
      // }

      //iteneray info prepopulate
      if (isEdit) {
        setFormData({
          ...formData,
          itineraryName: itineraryData?.itineraryName.replace(/draft/i, "").trim().replace(/\s+/g, " "),
          logo: packageData?.package_image,
        });
        setFormValues((prev) => ({
          ...prev,
          trip_image: itineraryData?.trip_image || "",
          description: itineraryData?.description || "",
        }));
        setItineraryDate(new Date(itineraryData?.itinerary_travel));
        setRepresentDate(
          itineraryData?.representative_date
            ? new Date(itineraryData?.representative_date)
            : new Date()
        );
        const selectedPck = packageOptions.find(
          (item) => item.id === parseInt(itineraryData?.packagedetailsid)
        );
        const selectedScl = schoolOptions.find(
          (item) => item.id === parseInt(itineraryData?.institutionid)
        );
        const selectedEqy = enquiryOptions.find(
          (item) => item.id === parseInt(itineraryData?.enquiryid)
        );
        console.log('selectedpk', selectedPck, itineraryData, packageOptions)
        setSelectedEnquiry(selectedEqy);
        setSelectedPackage(selectedPck);
        setSelectedSchool(selectedScl);
      }

      // setRender(!isRender)
    } catch (error) { }
  };
  // console.log(formData);
  const fetchPackageTypes = async () => {
    try {
      const payload = { type: "packagetype" };
      const result = await post("/getOptionList", payload);
      const options = result.data.map((item) => ({
        value: item.value,
        label: item.label,
        id: item.value,
      }));
      setPackageTypeOptions(options);
    } catch (error) {
      console.error("Error fetching package types:", error);
    }
  };

  const fetchHotelTypes = async () => {
    try {
      const payload = { type: "hotelname_hoteltype" };
      const result = await post("/getOptionList", payload);

      if (!isEdit) {
        setHotelNameOptions(result.data);
      }

      setAllHotelNames(result.data);
      // console.log('iusdomes',isDomestic)
      if (isDomestic) {
        const domesticOptions = result.data
          .filter(
            (item) =>
              typeof item.hoteltype === "string" &&
              item.hoteltype.toLowerCase().includes("hotel") //||
            // item.hoteltype?.toLowerCase().includes("resort")
          )
          .filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.hoteltype === item.hoteltype)
          );
        // console.log('first', selectedPackageType?.label, 'second', domesticOptions);

        setHotelTypeOptions(domesticOptions);
      } else {
        const options = [
          ...new Map(
            result.data
              .filter(
                (item) =>
                  typeof item.hoteltype === "string" &&
                  [
                    "Resort",
                    "Amusement Park",
                    "Campsite",
                    "Industrial Visit",
                  ].includes(item.hoteltype)
              )
              .map((item) => [item.hoteltype, item])
          ).values(),
        ];

        setHotelTypeOptions(options);
      }
    } catch (error) {
      console.error("Error fetching hotel types:", error);
    }
  };

  const fetchOnwardTransport = async () => {
    try {
      const payload = { type: "vehicaltype_vehicalname" };
      const result = await post("/getOptionList", payload);
      setOnwardTransportOptions(result.data);
      setReturnTransportOptions(result.data);
      setTransferOptions(result.data);
    } catch (error) {
      console.error("Error fetching onward transport:", error);
    }
  };

  const fetchAddons = async () => {
    try {
      const payload = { type: "addons_price" };
      const result = await post("/getOptionList", payload);
      setAddonOptions(result.data);
    } catch (error) {
      console.error("Error fetching addons:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const filterTransportOptions = (options, type) => {
    if (!options) return [];

    switch (type) {
      case "transfers":
        // Show only van/traveller options for transfers
        return options.filter(
          (option) =>
            !option.label.toLowerCase().includes("flight") &&
            !option.label.toLowerCase().includes("train") &&
            !option.label.toLowerCase().includes("bus")
        );

      case "onward":
      case "return":
        // Show only bus, train and flight options
        return options.filter(
          (option) =>
            option.label.toLowerCase().includes("flight") ||
            option.label.toLowerCase().includes("train") ||
            option.label.toLowerCase().includes("bus")
        );

      default:
        return options;
    }
  };

  const handleOnwardTransportChange = (index, selectedOption) => {
    // Update onward transport
    setTransportationSelections((prev) => {
      const updated = [...prev];
      updated[index].selectedOnwardTransport = selectedOption;
      return updated;
    });

    // Only set return for NON-domestic packages
    if (!(isDomestic || isDomesticDMC)) {
      if (!selectedOption?.vehicaltype?.toLowerCase().includes("bus")) {
        setReturnSelections([{ selectedReturnTransport: null, busCount: 1 }]);
      } else {
        setReturnSelections([{ selectedReturnTransport: null }]);
      }
    } else {
      // For domestic, reset return selections if onward is flight/train
      if (
        selectedOption?.vehicaltype === "Flight" ||
        selectedOption?.vehicaltype === "Train"
      ) {
        setReturnSelections([{ selectedReturnTransport: null }]);
      }
    }
  };

  const handleReturnTransportChange = (index, selectedOption) => {
    setReturnSelections((prev) => {
      const updated = [...prev];
      updated[index].selectedReturnTransport = selectedOption;
      return updated;
    });
  };

  const handleTransfersChange = (option) => {
    const selected = transferOptions.find(
      (transport) => transport.id === option.value
    );
    setSelectedTransfers(selected);
  };

  const handleAddTransferField = () => {
    setTransferSelections([
      ...transferSelections,
      { selectedTransfers: null, busCount: "1" },
    ]);
  };

  const handleAddonsChange = (selectedOptions) => {
    setSelectedAddons(selectedOptions);
    setShowExtraBF(
      selectedOptions?.some((option) =>
        option.label.toLowerCase().includes("extra breakfast")
      )
    );
    setShowExtraLunch(
      selectedOptions?.some((option) => option.label.includes("Extra Lunch"))
    );
    setShowExtraDinner(
      selectedOptions?.some((option) => option.label.includes("Extra Dinner"))
    );
    setTourManager(
      selectedOptions?.some((option) => option.label.includes("Tour manager"))
    );
  };

  const handleDayPlanChange = useCallback((dayNumber, planData) => {
    setDays((prevDays) =>
      prevDays.map((day) =>
        day.dayNumber === dayNumber
          ? {
            ...day,
            planName: planData.planName,
            timeSlots: planData.timeSlots,
            daywiseImage: planData.daywiseImage,
          }
          : day
      )
    );
  }, []);

  const handleDeleteDay = (dayNumber) => {
    setDays((prevDays) =>
      prevDays.filter((day) => day.dayNumber !== dayNumber)
    );
  };

  const handleMoveDayUp = (index) => {
    if (index === 0) return;
    setDays((prevDays) => {
      const newDays = [...prevDays];
      [newDays[index - 1], newDays[index]] = [newDays[index], newDays[index - 1]];
      return newDays.map((day, i) => ({ ...day, dayNumber: i + 1 }));
    });
  };

  const handleMoveDayDown = (index) => {
    if (index === days.length - 1) return;
    setDays((prevDays) => {
      const newDays = [...prevDays];
      [newDays[index], newDays[index + 1]] = [newDays[index + 1], newDays[index]];
      return newDays.map((day, i) => ({ ...day, dayNumber: i + 1 }));
    });
  };

  const handleEditorChange = (content, field) => {
    const safeContent = content.replace(/'/g, "`");

    setEditorContents((prev) => ({
      ...prev,
      [field]: safeContent,
    }));
  };
  // ✅ Main function: Fully optimized calculateTotalPrice
  const calculateTotalPrice = () => {
    let totalPrice = 0;

    // Utility conversion
    const toNumber = (val) => parseFloat(val) || 0;

    // Domestic hotel calculation
    const domesticHotelPrice = calculateHotelRoomPrice(
      hotelSelections,
      numberOfPax
    );

    let offSeasonPrice = 0;
    let peakSeasonPrice = 0;
    if (selectedPackageType?.label === "Domestic") {
      offSeasonPrice = domesticHotelPrice.offSeason;
      peakSeasonPrice = domesticHotelPrice.peakSeason;
    }
    // console.log(domesticHotelPrice, "domesticHotelPrice");
    // Transportation Calculations
    const calculateTransportCost = (selections, totalPax, setter) => {
      let totalCost = 0;
      selections?.forEach(
        ({
          selectedOnwardTransport,
          selectedReturnTransport,
          selectedTransfers,
          busCount,
        }) => {
          const transport =
            selectedOnwardTransport ||
            selectedReturnTransport ||
            selectedTransfers;

          if (!transport) return;

          const pph = toNumber(transport?.pph);
          const seats = toNumber(transport?.noofseats);
          const count = toNumber(busCount || 1);
          const overhead = toNumber(transport?.overheadprice || 0);

          // ✅ accumulate flights for markup exclusion (don’t reset on bus/train)
          // console.log(transport, "transport");
          if (setter) {
            if (transport?.vehicaltype.toLowerCase() === "flight") {
              setter(pph + overhead);
            } else {
              setter(0);
            }
          }

          if (
            transport?.vehicaltype === "Flight" ||
            transport?.vehicaltype === "Train"
          ) {
            // Flight/Train → full cost (per selection)
            totalCost += pph + overhead;
          } else {
            if (isDayouting || isDayvisit || isInternational || isDomesticDMC) {
              totalCost += ((pph * seats) + overhead) * count;
            }
            else {
              totalCost += ((pph * Number(formValues?.noofdays) * seats) + overhead) * count;
            }
          }
        }
      );

      // ✅ Check if any flight/train exists
      const hasFlightOrTrain = selections?.some(
        (s) =>
          s?.selectedOnwardTransport?.vehicaltype === "Flight" ||
          s?.selectedReturnTransport?.vehicaltype === "Flight" ||
          s?.selectedTransfers?.vehicaltype === "Flight" ||
          s?.selectedOnwardTransport?.vehicaltype === "Train" ||
          s?.selectedReturnTransport?.vehicaltype === "Train" ||
          s?.selectedTransfers?.vehicaltype === "Train"
      );

      return hasFlightOrTrain ? totalCost : totalCost / totalPax;
    };

    // console.log(returnReducedMarkup,'reduced---->>>',reducedMarkup)
    let onwardCost = 0,
      returnCost = 0,
      transferCost = 0;

    if (isDayouting || isDayvisit) {
      onwardCost = calculateTransportCost(
        transportationSelections,
        numberOfPax,
        setReducedMarkup
      );
    } else if (isDomestic || isDomesticDMC) {
      onwardCost = calculateTransportCost(
        transportationSelections,
        numberOfPax,
        setReducedMarkup
      );
      returnCost = calculateTransportCost(
        returnSelections,
        numberOfPax,
        setReturnReducedMarkup
      );
      transferCost = calculateTransportCost(
        transferSelections,
        numberOfPax,
        null
      );
    } else if (isInternational) {
      onwardCost = calculateTransportCost(
        transportationSelections,
        numberOfPax,
        setReducedMarkup
      );
      returnCost = calculateTransportCost(
        returnSelections,
        numberOfPax,
        setReturnReducedMarkup
      );
    }
    // Addons calculation (optimized)
    const excludedKeywords = [
      "Extra Breakfast",
      "Extra Lunch",
      "Extra Dinner",
      "Tour Manager",
    ];
    // Addons calculation (optimized)
    const addonsTotal = Array.isArray(selectedAddons)
      ? selectedAddons.reduce((sum, addon) => {
        const label = addon?.label?.toLowerCase() || "";
        if (excludedKeywords.some((k) => label.includes(k.toLowerCase())))
          return sum;

        const pph = toNumber(addon.pph);
        const totalPrice = toNumber(addon.totalprice);

        // Use per-head price if available, else fallback to total price divided by pax
        return (
          sum + (pph > 0 ? pph : numberOfPax ? totalPrice / numberOfPax : 0)
        );
      }, 0)
      : 0;

    // Extra Meals calculation
    const calculateExtra = (label, count) => {
      const addon = selectedAddons.find((a) =>
        a.label.toLowerCase().includes(label.toLowerCase())
      );
      if (!addon) return 0;

      const pph = toNumber(addon.pph);
      const totalPrice = toNumber(addon.totalprice);

      return pph > 0
        ? count * pph
        : numberOfPax
          ? (count * totalPrice) / numberOfPax
          : 0;
    };
    const calculateTourManagerExtra = (count) => {
      const addon = selectedAddons.find((a) =>
        a.label.toLowerCase().includes("tour manager")
      );
      if (!addon) return 0;

      const pph = toNumber(addon.pph);
      const totalPrice = toNumber(addon.totalprice);
      const noofdays = Number(formValues.noofdays);

      // If pph is available use it, else apply noOfDays logic
      if (pph > 0) {
        return count * pph;
      }

      if (numberOfPax) {
        return noofdays
          ? (noofdays * count * totalPrice) / numberOfPax
          : (count * totalPrice) / numberOfPax;
      }

      return 0;
    };

    const extraBFTotal = showExtraBF
      ? calculateExtra("Extra Breakfast", extraBFCount)
      : 0;
    const extraLunchTotal = showExtraLunch
      ? calculateExtra("Extra Lunch", extraLunchCount)
      : 0;
    const extraDinnerTotal = showExtraDinner
      ? calculateExtra("Extra Dinner", extraDinnerCount)
      : 0;
    const tourManagerTotal = tourManager
      ? calculateTourManagerExtra(tourManagerCount)
      : 0;

    setAddOnsAmount(
      addonsTotal +
      extraBFTotal +
      extraLunchTotal +
      extraDinnerTotal +
      tourManagerTotal
    );
    // Common Cost
    const commonCost =
      onwardCost +
      returnCost +
      transferCost +
      (selectedPackageType?.label === "Domestic"
        ? offSeasonPrice
          ? offSeasonPrice
          : peakSeasonPrice
        : Number(getHotalPricePrice(hotelSelections) || 0)) +
      addOnsAmount +
      Number(deviationAmount || 0);

    const {
      finalPrice: finalCommonCost,
      markupAmount,
      gstAmount,
    } = generateMarkupAndGST(commonCost);

    // Week based calculation for weekdays/weekends (non domestic)
    const hotelpriceWeektype = getHotelPricesWithDays(
      hotelSelections?.[0]?.options || []
    );

    setStudentWeekdayTotal(
      (hotelpriceWeektype.student.weekdays || 0) + finalCommonCost
    );
    setStudentWeekendTotal(
      (hotelpriceWeektype.student.weekends || 0) + finalCommonCost
    );
    setAdultWeekDayTotal(
      (hotelpriceWeektype.adult.weekdays || 0) + finalCommonCost
    );
    setAdultWeekendTotal(
      (hotelpriceWeektype.adult.weekends || 0) + finalCommonCost
    );
    // console.log(
    //   offSeasonPrice,
    //   peakSeasonPrice,
    //   "offSeasonPrice, peakSeasonPrice"
    // );
    // Store individual markups and GSTs
    const studentWeekdayCalc = generateMarkupAndGST(
      hotelpriceWeektype.student.weekdays +
      onwardCost +
      returnCost +
      transferCost +
      addOnsAmount +
      deviationAmount
    );
    const studentWeekendCalc = generateMarkupAndGST(
      hotelpriceWeektype.student.weekends +
      onwardCost +
      returnCost +
      transferCost +
      addOnsAmount +
      deviationAmount
    );
    const adultWeekdayCalc = generateMarkupAndGST(
      hotelpriceWeektype.adult.weekdays +
      onwardCost +
      returnCost +
      transferCost +
      addOnsAmount +
      deviationAmount
    );
    const adultWeekendCalc = generateMarkupAndGST(
      hotelpriceWeektype.adult.weekends +
      onwardCost +
      returnCost +
      transferCost +
      addOnsAmount +
      deviationAmount
    );
    // console.log("check weekday", studentWeekdayCalc, "studentWeekendCalc");
    // console.log("check weekday", adultWeekdayCalc, "adultWeekendCalc");

    setAllMarkups((prev) => ({
      ...prev,
      student: {
        ...prev.student,
        weekdays: studentWeekdayCalc.markupAmount,
        weekends: studentWeekendCalc.markupAmount,
      },
      adult: {
        weekdays: adultWeekdayCalc.markupAmount,
        weekends: adultWeekendCalc.markupAmount,
      },
    }));

    setAllGSTValues((prev) => ({
      ...prev,
      student: {
        ...prev.student,
        weekdays: studentWeekdayCalc.gstAmount,
        weekends: studentWeekendCalc.gstAmount,
      },
      adult: {
        weekdays: adultWeekdayCalc.gstAmount,
        weekends: adultWeekendCalc.gstAmount,
      },
    }));

    // Domestic Specific Off Season / Peak Season for Student
    if (selectedPackageType?.label === "Domestic") {
      const offSeasonCalc = generateMarkupAndGST(
        offSeasonPrice +
        onwardCost +
        returnCost +
        transferCost +
        addOnsAmount +
        deviationAmount
      );
      const peakSeasonCalc = generateMarkupAndGST(
        peakSeasonPrice +
        onwardCost +
        returnCost +
        transferCost +
        addOnsAmount +
        deviationAmount
      );
      setAllMarkups((prev) => ({
        ...prev,
        student: {
          ...prev.student,
          offSeason: offSeasonCalc.markupAmount,
          peakSeason: peakSeasonCalc.markupAmount,
        },
      }));

      setAllGSTValues((prev) => ({
        ...prev,
        student: {
          ...prev.student,
          offSeason: offSeasonCalc.gstAmount,
          peakSeason: peakSeasonCalc.gstAmount,
        },
      }));
    }
    // Store breakdown in state for UI
    setHotelPrice(getHotalPricePrice(hotelSelections));
    setOnWardTrnPrice(Math.round(onwardCost));
    setReturnTrnPrice(Math.round(returnCost));
    setTransfersPrice(Math.round(transferCost));
    setAddOnsPrice(addonsTotal);
    setMarkupAmount(markupAmount);
    setGstAmount(gstAmount);
    setOffSeasonPrice(Math.round(offSeasonPrice));
    setPeakSeasonPrice(Math.round(peakSeasonPrice));

    // Final total price logic
    totalPrice =
      (selectedPackageType?.label === "Domestic"
        ? domesticHotelPrice.offSeason + finalCommonCost
        : getHotalPricePrice(hotelSelections) + finalCommonCost) +
      Number(accommodationValue?.pph || 0);

    if (!isDayouting && selectedOption?.value) {
      const [ratio] = selectedOption.value.split(":")?.map(Number);
      if (ratio > 0) totalPrice = (totalPrice * (ratio + 1)) / ratio;
    }

    return Math.round(totalPrice);
  };

  useEffect(() => {
    const newTotal = calculateTotalPrice();
    // console.log(newTotal, "newTotal");
    setTotalPrice(newTotal);
  }, [
    // selectedHotel,
    selectedOnwardTransport,
    selectedReturnTransport,
    selectedTransfers,
    selectedAddons,
    extraBFCount,
    extraLunchCount,
    extraDinnerCount,
    tourManagerCount,
    tourManager,
    showExtraBF,
    showExtraLunch,
    showExtraDinner,
    numberOfPax,
    selectedOption,
    addOnsAmount,
    deviationAmount,
    days?.length,
    showSeasonalFields,
    selectedDate,
    hotelSelections,
    accommodationValue,
    transportationSelections,
    returnSelections,
    transferSelections,
    selectedPackageType?.label,
    reducedMarkup,
    returnReducedMarkup,
  ]);
  console.log('iternaryData', itineraryData)
  const getSignatureData = () => {
    if (sigCanvas.current) {
      return sigCanvas.current.toDataURL();
    }
    return null;
  };

  const totalAmountStudentWeekDays =
    getHotelPricesWithDays(hotelSelections[0]?.options).student.weekdays +
    onWardTrnPrice +
    returnTrnPrice +
    transfersPrice +
    addOnsAmount +
    deviationAmount;

  const totalAmountStudentWeekends =
    getHotelPricesWithDays(hotelSelections[0]?.options).student.weekends +
    onWardTrnPrice +
    returnTrnPrice +
    transfersPrice +
    addOnsAmount +
    deviationAmount;

  const totalAmountAdultWeekdays =
    getHotelPricesWithDays(hotelSelections[0]?.options).adult.weekdays +
    onWardTrnPrice +
    returnTrnPrice +
    transfersPrice +
    addOnsAmount +
    deviationAmount;

  const totalAmountAdultWeekEnds =
    getHotelPricesWithDays(hotelSelections[0]?.options).adult.weekends +
    onWardTrnPrice +
    returnTrnPrice +
    transfersPrice +
    addOnsAmount +
    deviationAmount;

  return (
    <div className="bg">
      <div className="block md:flex lg:flex justify-between">
        <div>
          <h2 className="text-primary-black text-[24px] font-semibold">
            Add Itinerary
          </h2>
          <p className="text-[12px]">
            <span className="font-bold">Itinerary</span> /
            <span className="font-regular">Add Itinerary</span>
          </p>
        </div>
        <div className="flex flex-wrap gap-4 mt-4 md:mt-0 justify-end">
          <Button
            className="w-full md:w-auto"
            disabled={!itineraryData?.itinerarydetailsid}
            title={!itineraryData?.itinerarydetailsid ? "Save the itinerary first to preview" : ""}
            onClick={() => {
              const id = itineraryData.itinerarydetailsid;
              const name = formData?.itineraryName || formValues.packagename || "";
              const slug = slugify(name);
              window.open(`/view/trip/${id}/${slug}`, "_blank");
            }}
            label={
              <span className="inline-flex items-center gap-1">
                Preview
                <span
                  className="material-symbols-outlined ml-2"
                  style={{
                    fontVariationSettings:
                      "'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24",
                  }}
                >
                  open_in_new
                </span>
              </span>
            }
          />
          <Button
            onClick={() => generateItineraryPDF({
            ...(freshItinerary ?? {}),
            packagename: formValues.packagename,
            packagetype: selectedPackageType?.label,
            itineraryname: formData?.itineraryName?.replace(/draft/i, "").trim().replace(/\s+/g, " "),
            dateoftravel: selectedItineraryDate || selectedDate,
            noofdays: Number(formValues.noofdays),
            noofnights: Number(formValues.noofnights),
            noofpax: numberOfPax,
            daywise_plan: days,
          })}
            label={
              <span className="inline-flex items-center gap-1">
                Export PDF
                <span className="material-symbols-outlined">
                  {" "}
                  picture_as_pdf{" "}
                </span>
              </span>
            }
            className="w-full md:w-auto"
          />
          {user?.role === "Admin" && selectedValue === "single" && (
            <Button
              type="primary"
              label={isEdit ? "Update" : "Save"}
              onClick={handleSavePackage}
              className="w-full md:w-auto"
            />
          )}
          <Button
            type="secondary"
            label="Cancel"
            onClick={handleNavigateBack}
            className="w-full md:w-auto"
          />
        </div>
      </div>
      <Paper className="my-8 pt-6 pb-6">
        <h1 className="text-[20px] font-bold mb-4">Itinerary Details</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div>
            <label className="text-[16px] font-semibold mb-2">
              Itinerary Name <span className="text-red-500">*</span>
            </label>
            <InputText
              placeholder="Enter Itinerary Name"
              value={formData?.itineraryName}
              onChange={handleItineraryNameChange}
            />
          </div>
          <div>
            <label className="text-[16px] font-semibold">
              {" "}
              Select Package <span className="text-red-500">*</span>
            </label>
            <SearchSelect
              placeholder="Packages"
              value={packageOptions.find(
                (option) => option.value === selectedPackage?.id
              )}
              options={packageOptions}
              onChange={(e) => handleFormSelection(e, "packages")}
              disabled={isEdit}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  cursor: isEdit ? "not-allowed" : "pointer",
                  backgroundColor: isEdit ? "#f3f4f6" : "white",
                }),
                option: (baseStyles) => ({
                  ...baseStyles,
                  cursor: isEdit ? "not-allowed" : "pointer",
                }),
              }}
            />
          </div>
          <div>
            <label className="text-[16px] font-semibold mb-2">
              Date of Travel <span className="text-red-500">*</span>
            </label>
            <DatePicker
              selectedDate={selectedItineraryDate}
              value={formData?.DateChange}
              onDateChange={handleItineraryDateChange}
              placeholder="Date"
            />
          </div>
          <div>
            <label className="text-[16px] font-semibold mb-2">
              Select Enquiry <span className="text-red-500">*</span>
            </label>
            <SearchSelect
              placeholder="Enquiries"
              value={enquiryOptions.find(
                (option) => option.value === selectedEnquiry?.id
              )}
              options={enquiryOptions}
              onChange={(e) => handleFormSelection(e, "enquirys")}
            />
          </div>
          <div>
            <label className="text-[16px] font-semibold mb-2">
              Select Institution <span className="text-red-500">*</span>
            </label>
            <SearchSelect
              placeholder="Institutions"
              value={schoolOptions.find(
                (option) => option.value === selectedSchool?.id
              )}
              options={schoolOptions}
              onChange={(e) => handleFormSelection(e, "schools")}
            />
          </div>
        </div>
      </Paper>

      {/* Trip Image & Description */}
      <Paper className="my-8 pt-6 pb-6">
        <h1 className="text-[20px] font-bold mb-4">Trip Image & Description</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="text-[16px] font-semibold mb-2">
              Trip Image URL
            </label>
            <InputText
              name="trip_image"
              value={formValues.trip_image}
              onChange={handleInputChange}
              placeholder="Enter trip image URL..."
            />
            {formValues.trip_image && (
              <img
                src={formValues.trip_image}
                alt="Trip preview"
                className="mt-2 h-32 w-48 object-cover rounded-md border"
                onError={(e) => { e.target.style.display = "none"; }}
              />
            )}
          </div>
          <div>
            <label className="text-[16px] font-semibold mb-2">
              Description
            </label>
            <textarea
              className="w-full border border-gray-300 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none"
              name="description"
              value={formValues.description}
              onChange={handleInputChange}
              placeholder="Enter trip description..."
              rows={4}
            />
          </div>
        </div>
      </Paper>

      <Paper className="my-8 pt-6 pb-6">
        <Paper className="my-8 mt-4 border">
          <h1 className="text-[18px] font-bold mb-4">Package Details</h1>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div className="col-span-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div>
                <label className="text-[16px] font-semibold mb-2">
                  Package Type <span className="text-red-500">*</span>
                </label>

                <Select
                  options={packageTypeOptions}
                  onChange={handlePackageTypeChange}
                  value={selectedPackageType}
                  placeholder="Select Package Type..."
                />
              </div>
              <div>
                <label className="text-[16px] font-semibold">
                  Package Name <span className="text-red-500">*</span>
                </label>
                <InputText
                  placeholder="Package Name..."
                  name="packagename"
                  value={formValues.packagename}
                  onChange={handleInputChange}
                />
              </div>
              <div>
                <label className="text-[16px] font-semibold mb-2">
                  Source <span className="text-red-500">*</span>
                </label>
                <InputText
                  name="city"
                  value={formValues.city}
                  onChange={handleInputChange}
                  placeholder="Enter source..."
                />{" "}
              </div>
              <div>
                <label className="text-[16px] font-semibold mb-2">
                  Destination <span className="text-red-500">*</span>
                </label>
                <InputText
                  name="destination"
                  value={formValues.destination}
                  onChange={handleInputChange}
                  placeholder="Enter destination..."
                />{" "}
              </div>
              {isDayouting ||
                (!isDayvisit && (
                  <>
                    <div>
                      <label className="text-[16px] font-semibold">
                        No. of Days{" "}
                        {!isDayouting && (
                          <span className="text-red-500">*</span>
                        )}
                      </label>
                      <InputText
                        value={formValues.noofdays}
                        type={"number"}
                        onChange={(e) =>
                          setFormValues((prev) => ({
                            ...prev,
                            noofdays: e.target.value,
                          }))
                        }
                        placeholder="Enter Days Count..."
                      />
                    </div>
                    <div>
                      <label className="text-[16px] font-semibold">
                        No. of Nights{" "}
                        {!isDayouting && (
                          <span className="text-red-500">*</span>
                        )}
                      </label>
                      <InputText
                        value={formValues.noofnights}
                        type={"number"}
                        onChange={(e) =>
                          setFormValues((prev) => ({
                            ...prev,
                            noofnights: e.target.value,
                          }))
                        }
                        placeholder="Enter Nights Count..."
                      />
                    </div>
                  </>
                ))}
            </div>

            <div className="mt-3">
              <Upload
                onFileSelect={handleUploadSelect}
                labelText="Upload Image"
                initialPreviewUrl={formData?.logo ? formData?.logo : null}
                fileValidation={validateFile}
                handleRemove={() => {
                  setFormData({ ...formData, logo: null });
                }}
              />
              {/* <p className="text-[12px] text-center text-[#ef4444]">Maximum file upload size is 300KB</p> */}
            </div>
          </div>
        </Paper>
        <Paper className="my-8 border p-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Main Form Fields */}
            <div className="col-span-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="col-span-3 flex flex-col gap-4 rounded-xl border-gray-300 p-4 mt-4 mb-2 border">
                <h1 className="text-[18px] font-bold">Total Pax and FOC</h1>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                  <div>
                    <label className="text-[16px] font-semibold">
                      No. of Pax <span className="text-red-500">*</span>
                      <span className="text-gray-700 text-sm mb-2 pl-2">
                        Exclude FOC
                      </span>
                    </label>
                    <InputText
                      placeholder="Enter number..."
                      type={"number"}
                      value={numberOfPax}
                      onChange={(e) => setNumberOfPax(Number(e.target.value))}
                    />{" "}
                  </div>

                  <div>
                    <label className="text-[16px] font-semibold">
                      No. of paid adults
                    </label>
                    <InputText
                      placeholder="Enter No. Paid Adults..."
                      type={"number"}
                      value={paidAdults}
                      onChange={(e) => setPaidAdults(Number(e.target.value))}
                    />
                  </div>
                  <div>
                    <label className="text-[16px] font-semibold">FOC</label>

                    <Select
                      options={options}
                      value={selectedOption}
                      onChange={handleChange}
                      placeholder="Select FOC..."
                    />
                  </div>
                  <div className="mt-6">
                    <label className="text-[16px] font-semibold">
                      Selected FOC: <b>{selectedFOC}</b>
                    </label>
                  </div>
                </div>
              </div>

              {(isDayouting || isDomestic) && (
                <div className="col-span-3 flex flex-col gap-4 rounded-xl border-gray-300 p-4 mt-4 mb-2 border">
                  <h1 className="text-[18px] font-bold ">Select Property</h1>
                  {hotelSelections?.map((selection, index) => (
                    <div key={index} className="w-full flex flex-wrap gap-4">
                      {/* Hotel Type */}
                      <div className="w-auto flex-none">
                        <label className="text-[16px] font-semibold mb-2">
                          Type <span className="text-red-500">*</span>
                        </label>
                        <SearchSelect
                          options={hotelTypeOptions}
                          onChange={(selectedOption) =>
                            handleHotelChanges(
                              selectedOption,
                              index,
                              "hotelType"
                            )
                          }
                          value={
                            hotelTypeOptions.filter(
                              (option) =>
                                option.hoteltype ===
                                selection.hotelType?.hoteltype
                            )[0] || null
                          }
                          placeholder="Select Property Type..."
                          displayLabel="hoteltype"
                        />
                      </div>

                      <div className="w-auto flex-none">
                        <label className="text-[16px] font-semibold mb-2">
                          Name <span className="text-red-500">*</span>
                        </label>
                        <SearchSelect
                          options={hotelNameOptions}
                          onChange={(selectedOption) =>
                            handleHotelChanges(
                              selectedOption,
                              index,
                              "hotelName"
                            )
                          }
                          value={allHotelNames.find(
                            (option) =>
                              option.label === selection.hotelName?.label
                          )}
                          placeholder="Select Property Name..."
                          displayLabel="name"
                        />
                      </div>

                      {/* Hotel Meal Plan */}
                      <div className="w-auto flex-none">
                        <label className="text-[16px] font-semibold mb-2">
                          Options <span className="text-red-500">*</span>
                        </label>

                        <SearchSelect
                          options={selection?.options || []}
                          placeholder="Select Property Options..."
                          onChange={(selectedOption) =>
                            handleHotelChanges(
                              selectedOption,
                              index,
                              "mealPlan"
                            )
                          }
                          value={selection?.mealPlan || null}
                          isDisabled={!selection.hotelType}
                        />
                      </div>

                      {/* Day */}
                      {isDomestic && (
                        <>
                          <div className="">
                            <label className="text-[16px] font-semibold mb-2">
                              Select Day <span className="text-red-500">*</span>
                            </label>
                            <MultiNewSelect
                              placeHolder="Select Days..."
                              options={dayOptions}
                              value={selection.day || null}
                              onChange={(selectedOption) =>
                                handleHotelChanges(selectedOption, index, "day")
                              }
                              isMulti
                              id="fileTypes"
                            />
                            {/* <Select
                                          options={dayOptions}
                                          placeholder="Select Day..."
                                          onChange={(selectedOption) =>
                                            handleHotelChanges(selectedOption, index, "day")
                                          }
                                          value={selection.day || null}
                                        /> */}
                          </div>
                          <div className="">
                            <label className="text-[16px] font-semibold mb-2">
                              No. of rooms{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <InputText
                              placeholder="Enter No. of Rooms..."
                              type={"number"}
                              value={selection?.noofRooms || 0}
                              onChange={(selectedOption) =>
                                handleHotelChanges(
                                  selectedOption.target.value,
                                  index,
                                  "rooms"
                                )
                              }
                            />
                          </div>
                        </>
                      )}
                      {/* Add/Delete Buttons */}
                      {!isDayouting && (
                        <div className="flex gap-2 mt-6">
                          {/* Delete button (hide if only one row) */}
                          {hotelSelections.length > 1 && (
                            <button
                              className="p-2 rounded bg-red-500 text-white flex justify-center items-center"
                              onClick={() => handleDeleteDayField(index)}
                            >
                              <span className="material-symbols-outlined">delete</span>
                            </button>
                          )}

                          {/* Add button (only on last row) */}
                          {index === hotelSelections.length - 1 && (
                            <button
                              className="p-2 rounded bg-black text-white flex justify-center items-center"
                              onClick={handleAddDayField}
                            >
                              <span className="material-symbols-outlined">add</span>
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
              <div className="col-span-3 flex flex-col gap-4 rounded-xl border-gray-300 p-4 mt-4 mb-2 border">
                <h1 className="text-[18px] font-bold">Select Transportation</h1>

                {/* ONWARD TRANSPORTATION */}
                {transportationSelections?.map((selection, index) => {
                  const selected = selection.selectedOnwardTransport;
                  const vehicalType =
                    selected?.vehicaltype?.toLowerCase?.() || "";

                  const isBus = vehicalType.includes("bus");
                  const isTrainOrFlight =
                    vehicalType.includes("train") ||
                    vehicalType.includes("flight");

                  return (
                    <div
                      key={index}
                      className="grid grid-cols-1 md:grid-cols-3 gap-6"
                    >
                      {/* ✅ Always Show This */}
                      <div>
                        <label className="text-[16px] font-semibold">
                          {transportationSelections?.some((item) =>
                            item?.selectedOnwardTransport?.vehicaltype?.includes(
                              "seater"
                            )
                          ) || isDomestic
                            ? "Onward Transportation"
                            : "Transportation"}{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <SearchSelect
                          options={filterTransportOptions(
                            onwardTransportOptions,
                            selectedPackageType?.label
                          )}
                          value={selection.selectedOnwardTransport}
                          onChange={(val) =>
                            handleOnwardTransportChange(index, val)
                          }
                          placeholder="Select Onward Transportation..."
                        />
                      </div>

                      {/* ✅ Only show Bus Count section if Domestic, Day Visit, Day Outing, DMC and NOT flight/train */}
                      {(isDayouting ||
                        isDayvisit ||
                        isDomestic ||
                        isDomesticDMC) &&
                        !isTrainOrFlight && (
                          <>
                            <div>
                              <label className="text-[16px] font-semibold">
                                Enter Bus Count{" "}
                                <span className="text-red-500">*</span>
                              </label>
                              <InputText
                                type="number"
                                min="1"
                                placeholder="Enter Count..."
                                value={selection.busCount ?? 1}
                                onChange={(e) =>
                                  handleUpdateBusCount(index, e.target.value)
                                }
                              />
                            </div>

                            <div className="flex gap-2 mt-6">
                              {/* Add Button - Only show on last row */}
                              {index ===
                                transportationSelections.length - 1 && (
                                  <button
                                    className="p-2 rounded bg-black text-white"
                                    onClick={handleAddTransField}
                                  >
                                    <span className="material-symbols-outlined">
                                      add
                                    </span>
                                  </button>
                                )}

                              {/* Delete Button - Show if more than one row */}
                              {transportationSelections.length > 1 && (
                                <button
                                  className="p-2 rounded bg-red-500 text-white"
                                  onClick={() => handleDeleteTransField(index)}
                                >
                                  <span className="material-symbols-outlined">
                                    delete
                                  </span>
                                </button>
                              )}
                            </div>
                          </>
                        )}
                    </div>
                  );
                })}

                {/* RETURN & TRANSFER TRANSPORTATION */}
                {/** NOT Applicable for Day Outing and Day Visit */}
                {!isDayouting && !isDayvisit && (
                  <>
                    {/* RETURN TRANSPORTATION (Domestic, Domestic DMC, International) */}
                    {!transportationSelections?.some((item) =>
                      item?.selectedOnwardTransport?.vehicaltype?.includes(
                        "seater"
                      )
                    ) &&
                      returnSelections?.map((selection, index) => (
                        <div
                          key={index}
                          className="grid grid-cols-1 md:grid-cols-3 gap-6"
                        >
                          <div>
                            <label className="text-[16px] font-semibold">
                              Return Transportation{" "}
                              <span className="text-red-500">
                                {!transportationSelections?.some((item) =>
                                  item?.selectedOnwardTransport?.vehicaltype?.includes(
                                    "flight" || "train"
                                  )
                                )
                                  ? ""
                                  : "*"}
                              </span>
                            </label>
                            <SearchSelect
                              options={filterTransportOptions(
                                returnTransportOptions,
                                selectedPackageType?.label
                              )}
                              value={selection.selectedReturnTransport}
                              onChange={(val) =>
                                handleReturnTransportChange(index, val)
                              }
                              placeholder="Select Return Transportation..."
                            />
                          </div>
                        </div>
                      ))}

                    {/* TRANSFER TRANSPORTATION (Only Domestic shows transfers) */}
                    {(isDomestic || isDomesticDMC) &&
                      transferSelections?.map((selection, index) => {
                        const isTrainOrFlight =
                          selection?.selectedTransfers?.label
                            ?.toLowerCase()
                            ?.includes("train") ||
                          selection?.selectedTransfers?.label
                            ?.toLowerCase()
                            ?.includes("flight");

                        return (
                          <div
                            key={index}
                            className="grid grid-cols-1 md:grid-cols-3 gap-6"
                          >
                            <div>
                              <label className="text-[16px] font-semibold mb-2">
                                Transfers <span className="text-red-500"></span>
                              </label>
                              <SearchSelect
                                options={filterTransferOptions(
                                  transferOptions,
                                  selectedPackageType?.label
                                )}
                                value={selection?.selectedTransfers || null}
                                onChange={(option) =>
                                  handleTransfersChange(option, index)
                                }
                                placeholder="Select Transfers..."
                              />
                            </div>

                            {/* Bus Count only for Domestic Transfers */}
                            {!isTrainOrFlight && (
                              <>
                                <div>
                                  <label className="text-[16px] font-semibold">
                                    Enter Bus Count{" "}
                                    <span className="text-red-500"></span>
                                  </label>
                                  <InputText
                                    type="number"
                                    min="1"
                                    placeholder="Enter Count..."
                                    value={selection.busCount ?? 1}
                                    onChange={(e) =>
                                      handleTransferBusCountChange(
                                        index,
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>

                                <div className="flex gap-2 mt-6">
                                  {index === transferSelections.length - 1 && (
                                    <button
                                      className="p-2 rounded bg-black text-white"
                                      onClick={handleAddTransferField}
                                    >
                                      <span className="material-symbols-outlined">
                                        add
                                      </span>
                                    </button>
                                  )}
                                  {transferSelections?.length > 1 && (
                                    <button
                                      className="p-2 rounded bg-red-500 text-white"
                                      onClick={() =>
                                        handleDeleteTransferField(index)
                                      }
                                    >
                                      <span className="material-symbols-outlined">
                                        delete
                                      </span>
                                    </button>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                        );
                      })}
                  </>
                )}
              </div>

              <div className="col-span-3 flex flex-col gap-4 rounded-xl border-gray-300 p-4 mt-4 mb-2 border">
                <h1 className="text-[18px] font-bold">Select Addons</h1>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  <div>
                    <label className="text-[16px] font-semibold mb-2">
                      Addons <span className="text-red-500 ">*</span>
                    </label>
                    <MultiNewSelect
                      // className="form-control"
                      placeHolder="Select Addons..."
                      options={addonOptions}
                      // name="fileTypes"
                      value={selectedAddons}
                      onChange={(e) => handleAddonsChange(e, "addons")}
                      isMulti
                      id="fileTypes"
                    />
                    {/* <MultiSelect
                        options={addonOptions}
                        value={selectedAddons}
                        onChange={handleAddonsChange}
                        placeholder="Select Addons..."
                      /> */}
                  </div>

                  {Array.isArray(extraItems) &&
                    extraItems.map(
                      ({ show, label, value, setter }) =>
                        show && (
                          <div key={label}>
                            <label className="text-[16px] font-semibold">
                              {label} <span className="text-red-500">*</span>
                            </label>
                            <InputText
                              type="number"
                              min="1"
                              placeholder="Enter Count..."
                              value={value}
                              onChange={(e) =>
                                setter(Math.max(1, Number(e.target.value)))
                              }
                            />
                          </div>
                        )
                    )}
                  <div>
                    <label className="text-[16px] font-semibold">
                      AddOns Calculated Amount{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <InputText
                      placeholder="Enter Amount..."
                      type={"number"}
                      value={Math.round(addOnsAmount)}
                      onChange={(e) => setAddOnsAmount(Number(e.target.value))}
                    />
                  </div>
                </div>
              </div>

              <div>
                <label className="text-[16px] font-semibold">
                  Deviation Allowed Amount{" "}
                  <span className="text-red-500">*</span>
                </label>
                <InputText
                  placeholder="Enter Amount..."
                  type={"number"}
                  value={deviationAmount}
                  onChange={(e) => setDeviationAmount(Number(e.target.value))}
                />{" "}
              </div>
            </div>

            {/* Price Box */}
            <div className="bg-[#CDD8CB] p-6 rounded-lg max-w-sm mx-auto text-left flex flex-col justify-center items-center min-h-[200px]">
              {/* Content Centered */}
              <div className="flex items-center gap-1 mb-6">
                <div className="text-center">
                  <label className="text-[16px] font-semibold mb-0 text-center mb-4">
                    Date of Travel
                  </label>
                  <DatePicker
                    selectedDate={selectedDate}
                    onDateChange={(date) => handleDateChange(date)}
                    placeholderText="Start Date"
                    className="w-full mt-0"
                  />
                </div>
              </div>
              <span className="material-symbols-outlined text-gray-700 text-3xl mb-2">
                payments
              </span>
              <div className="mb-5">
                <div className="text-gray-700 text-sm mb-2 text-center">
                  Price per Student
                </div>

                {selectedPackageType?.label === "Domestic" ? (
                  <>
                    {/* Peak Season */}

                    {offSeasonPrice > 0 && (
                      <div className="text-[22px] font-bold text-black mb-0 text-center">
                        <span className="text-[12px]">Off Season:</span> ₹{" "}
                        {focHandler(
                          Math.round(
                            offSeasonPrice +
                            onWardTrnPrice +
                            returnTrnPrice +
                            transfersPrice +
                            addOnsAmount +
                            deviationAmount +
                            (allMarkups.student.offSeason
                              ?? markupAmount) +
                            (allGSTValues.student.offSeason
                              ?? gstAmount)
                          ),
                          numberOfPax
                        )}
                      </div>
                    )}
                    {peakSeasonPrice > 0 && (
                      <div className="text-[22px] font-bold text-black mb-0 text-center">
                        <span className="text-[12px]">Peak Season:</span> ₹{" "}
                        {focHandler(
                          Math.round(
                            peakSeasonPrice +
                            onWardTrnPrice +
                            returnTrnPrice +
                            transfersPrice +
                            addOnsAmount +
                            deviationAmount +
                            (typeof allMarkups?.student?.peakSeason ===
                              "number"
                              ? allMarkups.student.peakSeason
                              : markupAmount) +
                            (typeof allGSTValues?.student?.peakSeason ===
                              "number"
                              ? allGSTValues.student.peakSeason
                              : gstAmount)
                          ),
                          numberOfPax
                        )}
                      </div>
                    )}

                    {/* Off Season */}
                    {/* {offSeasonPrice > 0 && (
                          <div className="text-[22px] font-bold text-black mb-4 text-center">
                            <span className="text-[12px]">Off Season:</span> ₹{" "}
                            {Math.round(
                              offSeasonPrice +
                                onWardTrnPrice +
                                returnTrnPrice +
                                transfersPrice +
                                addOnsAmount +
                                deviationAmount +
                                markupAmount +
                                gstAmount
                            )}
                          </div>
                        )} */}
                  </>
                ) : selectedPackageType?.label ===
                  "Day Visit - Local sightseeing" ? (
                  <div className="text-[22px] font-bold text-black mb-0 text-center">
                    ₹{" "}
                    {focHandler(
                      Math.round(
                        totalAmountStudentWeekDays +
                        (allMarkups?.student?.weekdays || 0) +
                        (allGSTValues?.student?.weekdays || 0)
                      ),
                      numberOfPax
                    )}
                  </div>
                ) : selectedPackageType?.label === "Domestic - DMC" ? (
                  <div className="text-[22px] font-bold text-black mb-0 text-center">
                    ₹{" "}
                    {focHandler(
                      Math.round(
                        totalAmountStudentWeekDays +
                        (allMarkups?.student?.weekdays || 0) +
                        (allGSTValues?.student?.weekdays || 0)
                      ),
                      numberOfPax
                    )}
                  </div>
                ) : selectedPackageType?.label === "International" ? (
                  <div className="text-[22px] font-bold text-black mb-0 text-center">
                    ₹{" "}
                    {focHandler(
                      Math.round(
                        totalAmountStudentWeekDays +
                        (allMarkups?.student?.weekdays || 0) +
                        (allGSTValues?.student?.weekdays || 0)
                      ),
                      numberOfPax
                    )}
                  </div>
                ) : (
                  <>
                    {/* Weekdays (Non-domestic fallback) */}
                    {hotelSelections?.length > 0 &&
                      hotelSelections[0]?.value != 0 &&
                      totalAmountStudentWeekDays > 0 && (
                        <div className="text-[22px] font-bold text-black mb-0 text-center">
                          <span className="text-[12px]">
                            {selectedPackageType?.label === "International"
                              ? ""
                              : "Weekdays:"}
                          </span>
                          ₹{" "}
                          {focHandler(
                            Math.round(
                              totalAmountStudentWeekDays +
                              (allMarkups?.student?.weekdays || 0) +
                              (allGSTValues?.student?.weekdays || 0)
                            ),
                            numberOfPax
                          )}
                        </div>
                      )}

                    {/* Weekends – only show if hotel is selected and totalAmount > 0 */}
                    {hotelSelections?.length > 0 &&
                      hotelSelections[0]?.value != 0 &&
                      totalAmountStudentWeekends > 0 && (
                        <div className="text-[22px] font-bold text-black mb-4 text-center">
                          <span className="text-[12px]">Weekends:</span> ₹{" "}
                          {focHandler(
                            Math.round(
                              totalAmountStudentWeekends +
                              (allMarkups?.student?.weekends || 0) +
                              (allGSTValues?.student?.weekends || 0)
                            ),
                            numberOfPax
                          )}
                        </div>
                      )}
                  </>
                )}
              </div>

              {/* {isDayouting && (
                <div className="mb-5">
                  <div className="text-gray-700 text-sm mb-2 text-center">
                    Price per Adult
                  </div>

                  {hotelSelections?.length > 0 &&
                    hotelSelections[0]?.value != 0 &&
                    totalAmountAdultWeekdays > 0 && (
                      <div className="text-[22px] font-bold text-black mb-0 text-center">
                        <span className="text-[12px]">Weekdays:</span> ₹{" "}
                        {focHandler(
                          Math.round(
                            totalAmountAdultWeekdays +
                              (allMarkups?.adult?.weekdays || 0) +
                              (allGSTValues?.adult?.weekdays || 0)
                          ),
                          numberOfPax
                        )}
                      </div>
                    )}

                  {hotelSelections?.length > 0 &&
                    hotelSelections[0]?.value != 0 &&
                    totalAmountAdultWeekEnds > 0 && (
                      <div className="text-[22px] font-bold text-black mb-4 text-center">
                        <span className="text-[12px]">Weekends:</span> ₹{" "}
                        {focHandler(
                          Math.round(
                            totalAmountAdultWeekEnds +
                              (allMarkups?.adult?.weekends || 0) +
                              (allGSTValues?.adult?.weekends || 0)
                          ),
                          numberOfPax
                        )}
                      </div>
                    )}
                </div>
              )} */}

              <div className="text-xs text-gray-600 mb-4 text-center">
                **The above amount is based on the headcount and selected
                add-ons. It may change if the count is updated. This amount may
                vary when FOC is applied.
              </div>

              {/* Button Centered */}
              {(user?.role === "Admin" ||
                user?.role === "Backend Team Manager") && (
                  <button
                    className="bg-transparent text-black border border-black hover:bg-gray-100 h-[40px] md:h-[42px] leading-[10px] text-[16px] md:text-[16px]"
                    onClick={handleOpenPriceModal}
                  >
                    Price Breakdown
                  </button>
                )}
            </div>

            {isPriceModalOpen && (
              <div
                id="modal-overlay"
                className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
                onClick={handleClosePriceModal}
              >
                <div
                  className="bg-white p-6 rounded-lg shadow-lg max-w-fit w-full relative"
                  onClick={(e) => e.stopPropagation()}
                >
                  <h2 className="text-xl font-bold mb-4">Price Breakdown</h2>
                  <div className="overflow-auto">
                    <table className="table-auto w-full border-collapse whitespace-nowrap md:whitespace-nowrap  lg:whitespace-normal">
                      <thead>
                        <tr>
                          <th className="border p-2" rowSpan={2}></th>
                          <th className="border p-2">Property</th>
                          <th className="border p-2" colSpan={3}>
                            Transportation
                          </th>
                          <th className="border p-2">Addons</th>
                          <th className="border p-2" rowSpan={2}>
                            Deviation
                          </th>
                          <th className="border p-2" rowSpan={2}>
                            Markup ({settingsMarkupValue}%)
                          </th>
                          <th className="border p-2" rowSpan={2}>
                            GST ({settingsGSTValue}%)
                          </th>
                          <th className="border p-2" rowSpan={2}>
                            Total Amount
                          </th>
                        </tr>
                        <tr>
                          <th className="border p-2">
                            {hotelSelections?.length
                              ? hotelSelections
                                .filter((hotel, index, self) => {
                                  const name =
                                    hotel?.hotelName?.label ?? "No Property";
                                  return (
                                    index ===
                                    self.findIndex(
                                      (h) =>
                                        (h?.hotelName?.label ??
                                          "No Property") === name
                                    )
                                  );
                                })
                                .map((hotel, idx, arr) => (
                                  <span key={`hotel-${idx}`}>
                                    {hotel?.hotelType?.hoteltype
                                      ? `${hotel.hotelType.hoteltype} - ${hotel?.hotelName?.label ??
                                      "No Property"
                                      }`
                                      : hotel?.hotelName?.label ??
                                      "No Property"}
                                    {idx !== arr.length - 1 && ", "}
                                  </span>
                                ))
                              : "No Property selected"}
                          </th>
                          <th className="border p-2">Onward</th>
                          <th className="border p-2">Return</th>
                          <th className="border p-2">Transfers</th>
                          <th className="border p-2 capitalize">
                            {selectedAddons
                              ?.map((item) => item?.label)
                              .join(", ")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* Student Pricing */}
                        {selectedPackageType?.label === "Domestic" ? (
                          <>
                            {offSeasonPrice > 0 && (
                              <tr>
                                <td className="border p-2 text-center font-bold">
                                  Off Season
                                </td>
                                <td className="border p-2 text-center">
                                  ₹ {offSeasonPrice}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹ {onWardTrnPrice}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹ {returnTrnPrice}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹ {transfersPrice}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹ {Math.round(addOnsAmount)}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹ {deviationAmount}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹{" "}
                                  {allMarkups?.student.offSeason ?? markupAmount}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹ {allGSTValues?.student.offSeason ?? gstAmount}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹{" "}
                                  {focHandler(
                                    Math.round(
                                      offSeasonPrice +
                                      onWardTrnPrice +
                                      returnTrnPrice +
                                      transfersPrice +
                                      addOnsAmount +
                                      deviationAmount +
                                      (allMarkups.student.offSeason ??
                                        markupAmount) +
                                      (allGSTValues.student.offSeason
                                        ?? gstAmount)
                                    ),
                                    numberOfPax
                                  )}
                                </td>
                              </tr>
                            )}

                            {peakSeasonPrice > 0 && (
                              <tr>
                                <td className="border p-2 text-center font-bold">
                                  Peak Season
                                </td>
                                <td className="border p-2 text-center">
                                  ₹ {Math.round(peakSeasonPrice)}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹ {onWardTrnPrice}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹ {returnTrnPrice}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹ {transfersPrice}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹ {Math.round(addOnsAmount)}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹ {deviationAmount}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹{" "}
                                  {allMarkups?.student.peakSeason ?? markupAmount}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹{" "}
                                  {allGSTValues?.student.peakSeason ?? gstAmount}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹{" "}
                                  {focHandler(
                                    Math.round(
                                      peakSeasonPrice +
                                      onWardTrnPrice +
                                      returnTrnPrice +
                                      transfersPrice +
                                      addOnsAmount +
                                      deviationAmount +
                                      (typeof allMarkups?.student
                                        ?.peakSeason === "number"
                                        ? allMarkups.student.peakSeason
                                        : markupAmount) +
                                      (typeof allGSTValues?.student
                                        ?.peakSeason === "number"
                                        ? allGSTValues.student.peakSeason
                                        : gstAmount)
                                    ),
                                    numberOfPax
                                  )}
                                </td>
                              </tr>
                            )}
                          </>
                        ) : selectedPackageType?.label === "International" ? (
                          ["weekdays"].map((type) => {
                            const studentPrice =
                              getHotelPricesWithDays(hotelSelections[0]?.options)
                                ?.student?.[type] || 0;

                            const hasTransportData =
                              onWardTrnPrice > 0 ||
                              returnTrnPrice > 0 ||
                              transfersPrice > 0 ||
                              addOnsAmount > 0;

                            if (studentPrice > 0 || hasTransportData) {
                              return (
                                <tr key={type}>
                                  <td className="border p-2 text-center font-bold">
                                    Price per head
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {studentPrice}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {onWardTrnPrice}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {returnTrnPrice}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {transfersPrice}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {Math.round(addOnsAmount)}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {deviationAmount}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {allMarkups?.student[type] ?? markupAmount}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {allGSTValues?.student[type] ?? gstAmount}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹{" "}
                                    {focHandler(
                                      Math.round(
                                        studentPrice +
                                        onWardTrnPrice +
                                        returnTrnPrice +
                                        transfersPrice +
                                        addOnsAmount +
                                        deviationAmount +
                                        (allMarkups?.student[type] > 0
                                          ? allMarkups.student[type]
                                          : markupAmount) +
                                        (allGSTValues?.student[type] > 0
                                          ? allGSTValues.student[type]
                                          : gstAmount)
                                      ),
                                      numberOfPax
                                    )}
                                  </td>
                                </tr>
                              );
                            }

                            return null;
                          })
                        ) : selectedPackageType?.label === "Domestic - DMC" ? (
                          ["weekdays"].map((type) => {
                            const studentPrice =
                              getHotelPricesWithDays(hotelSelections[0]?.options)
                                ?.student?.[type] || 0;

                            const hasTransportData =
                              onWardTrnPrice > 0 ||
                              returnTrnPrice > 0 ||
                              transfersPrice > 0 ||
                              addOnsAmount > 0;

                            if (studentPrice > 0 || hasTransportData) {
                              return (
                                <tr key={type}>
                                  <td className="border p-2 text-center font-bold">
                                    Price per head
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {studentPrice}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {onWardTrnPrice}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {returnTrnPrice}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {transfersPrice}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {Math.round(addOnsAmount)}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {deviationAmount}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {allMarkups?.student[type] ?? markupAmount}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {allGSTValues?.student[type] ?? gstAmount}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹{" "}
                                    {focHandler(
                                      Math.round(
                                        studentPrice +
                                        onWardTrnPrice +
                                        returnTrnPrice +
                                        transfersPrice +
                                        addOnsAmount +
                                        deviationAmount +
                                        (allMarkups?.student[type] > 0
                                          ? allMarkups.student[type]
                                          : markupAmount) +
                                        (allGSTValues?.student[type] > 0
                                          ? allGSTValues.student[type]
                                          : gstAmount)
                                      ),
                                      numberOfPax
                                    )}
                                  </td>
                                </tr>
                              );
                            }

                            return null;
                          })
                        ) : selectedPackageType?.label ===
                          "Day Visit - Local sightseeing" ? (
                          ["weekdays"].map((type) => {
                            const studentPrice =
                              getHotelPricesWithDays(hotelSelections[0]?.options)
                                ?.student?.[type] || 0;

                            const hasTransportData =
                              onWardTrnPrice > 0 ||
                              returnTrnPrice > 0 ||
                              transfersPrice > 0 ||
                              addOnsAmount > 0;

                            if (studentPrice > 0 || hasTransportData) {
                              return (
                                <tr key={type}>
                                  <td className="border p-2 text-center font-bold">
                                    Price per head
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {studentPrice}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {onWardTrnPrice}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {returnTrnPrice}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {transfersPrice}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {Math.round(addOnsAmount)}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {deviationAmount}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {allMarkups?.student[type] ?? markupAmount}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {allGSTValues?.student[type] ?? gstAmount}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹{" "}
                                    {focHandler(
                                      Math.round(
                                        studentPrice +
                                        onWardTrnPrice +
                                        returnTrnPrice +
                                        transfersPrice +
                                        addOnsAmount +
                                        deviationAmount +
                                        (allMarkups?.student[type] > 0
                                          ? allMarkups.student[type]
                                          : markupAmount) +
                                        (allGSTValues?.student[type] > 0
                                          ? allGSTValues.student[type]
                                          : gstAmount)
                                      ),
                                      numberOfPax
                                    )}
                                  </td>
                                </tr>
                              );
                            }

                            return null;
                          })
                        ) : (
                          ["weekdays", "weekends"].map((type) => {
                            const hotelSelected =
                              String(hotelSelections[0]?.value) !== "0";
                            const studentPrice =
                              getHotelPricesWithDays(hotelSelections[0]?.options)
                                ?.student?.[type] || 0;

                            const hasTransportData =
                              onWardTrnPrice > 0 ||
                              returnTrnPrice > 0 ||
                              transfersPrice > 0 ||
                              addOnsAmount > 0;

                            if (
                              hotelSelected &&
                              (studentPrice > 0 || hasTransportData)
                            ) {
                              return (
                                <tr key={type}>
                                  <td className="border p-2 text-center font-bold">
                                    Student ({type})
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {studentPrice}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {onWardTrnPrice}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {returnTrnPrice}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {transfersPrice}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {Math.round(addOnsAmount)}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {deviationAmount}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {allMarkups?.student[type] ?? markupAmount}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹ {allGSTValues?.student[type] ?? gstAmount}
                                  </td>
                                  <td className="border p-2 text-center">
                                    ₹{" "}
                                    {focHandler(
                                      Math.round(
                                        studentPrice +
                                        onWardTrnPrice +
                                        returnTrnPrice +
                                        transfersPrice +
                                        addOnsAmount +
                                        deviationAmount +
                                        (allMarkups?.student[type] > 0
                                          ? allMarkups.student[type]
                                          : markupAmount) +
                                        (allGSTValues?.student[type] > 0
                                          ? allGSTValues.student[type]
                                          : gstAmount)
                                      ),
                                      numberOfPax
                                    )}
                                  </td>
                                </tr>
                              );
                            }

                            return null;
                          })
                        )}

                        {/* Adult Pricing */}
                        {["weekdays", "weekends"].map((type) => {
                          const hotelSelected = hotelSelections[0]?.value !== "0"; // Check if hotel is selected
                          const adultPrice =
                            getHotelPricesWithDays(hotelSelections[0]?.options)
                              ?.adult[type] || 0;

                          return (
                            hotelSelected &&
                            adultPrice > 0 && (
                              <tr key={`adult-${type}`}>
                                <td className="border p-2 text-center font-bold">
                                  Adult ({type})
                                </td>
                                <td className="border p-2 text-center">
                                  ₹ {adultPrice}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹ {onWardTrnPrice}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹ {returnTrnPrice}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹ {transfersPrice}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹ {Math.round(addOnsAmount)}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹ {deviationAmount}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹{" "}
                                  {allMarkups?.adult[type]
                                    ? allMarkups?.adult[type]
                                    : markupAmount}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹{" "}
                                  {allGSTValues?.adult[type]
                                    ? allGSTValues?.adult[type]
                                    : gstAmount}
                                </td>
                                <td className="border p-2 text-center">
                                  ₹{" "}
                                  {focHandler(
                                    Math.round(
                                      adultPrice +
                                      onWardTrnPrice +
                                      returnTrnPrice +
                                      transfersPrice +
                                      addOnsAmount +
                                      deviationAmount +
                                      (allMarkups?.adult[type]
                                        ? allMarkups?.adult[type]
                                        : markupAmount) +
                                      (allGSTValues?.adult[type]
                                        ? allGSTValues?.adult[type]
                                        : gstAmount)
                                    ),
                                    numberOfPax
                                  )}
                                </td>
                              </tr>
                            )
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <button
                    className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
                    onClick={handleClosePriceModal}
                  >
                    ✕
                  </button>
                </div>
              </div>
            )}
          </div>
        </Paper>

        <div className="bg-white rounded-xl border-gray-300 p-4 my-8 border">
          <h1 className="text-[20px] font-bold mb-4">Day-wise Planning</h1>
          <div className="grid grid-cols-1 gap-4">
            {!isFirstDayAdded ? (
              <Paper className="border-2 border-dashed border-black p-8  flex justify-center items-center flex-col">
                <button
                  onClick={handleAddDay}
                  className=" bg-white text-black border border-black rounded-md py-2 px-12 text-lg mb-4 mt-4"
                >
                  Add Day
                </button>
                <p className="text-center text-gray-500 mt-4">
                  No day plan to display
                </p>
              </Paper>
            ) : (
              <div className="grid grid-cols-1 lg:grid-cols-2 items-start gap-4">
                {days.map((day, index) => (
                  <div key={day.dayNumber} className="w-full">
                    <DayPlan
                      dayNumber={day.dayNumber}
                      initialTimeSlots={day.timeSlots}
                      planName01={day.planName}
                      daywiseImage={day.daywiseImage}
                      setDays={setDays}
                      onChange={(planData) =>
                        handleDayPlanChange(planData?.dayNumber, planData)
                      }
                      onDelete={() => handleDeleteDay(day.dayNumber)}
                      isFirstDay={index === 0}
                      isLastDay={index === days.length - 1}
                      onMoveUp={() => handleMoveDayUp(index)}
                      onMoveDown={() => handleMoveDayDown(index)}
                      onwardTransportOptions={onwardTransportOptions}
                      returnTransportOptions={returnTransportOptions}
                      transferOptions={transferOptions}
                      hotelNameOptions={allHotelNames}
                      hotelTypeOptions={hotelTypeOptions}
                    />
                  </div>
                ))}

                <Paper className="border-2 border-dashed border-black p-8  flex justify-center items-center flex-col">
                  <button
                    onClick={handleAddDay}
                    className=" bg-white text-black border border-black rounded-md py-2 px-12 text-lg"
                  >
                    Add Day
                  </button>
                </Paper>
              </div>
            )}
          </div>
        </div>
        <div className="container mx-auto py-6">
          <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-6">
            <div>
              <label className="text-[16px] font-semibold mb-4 block">
                Transportation Details <span className="text-red-500">*</span>
              </label>
              <TextEditor
                initialValue={editorContents.transportation_details}
                onChange={(content) =>
                  handleEditorChange(content, "transportation_details")
                }
              />
            </div>
            <div>
              <label className="text-[16px] font-semibold mb-4 block">
                Hotel Details <span className="text-red-500">*</span>
              </label>
              <TextEditor
                initialValue={editorContents.hotel_details}
                onChange={(content) =>
                  handleEditorChange(content, "hotel_details")
                }
              />
            </div>
            <div>
              <label className="text-[16px] font-semibold mb-4 block">
                Meal Plan <span className="text-red-500">*</span>
              </label>
              <TextEditor
                initialValue={editorContents.meal_plan}
                onChange={(content) => handleEditorChange(content, "meal_plan")}
              />
            </div>
            <div>
              <label className="text-[16px] font-semibold mb-4 block">
                Inclusions <span className="text-red-500">*</span>
              </label>
              <TextEditor
                initialValue={editorContents.inclusions}
                onChange={(content) =>
                  handleEditorChange(content, "inclusions")
                }
              />
            </div>
            <div>
              <label className="text-[16px] font-semibold mb-4 block">
                Exclusions<span className="text-red-500">*</span>
              </label>
              <TextEditor
                initialValue={editorContents.exclusions}
                onChange={(content) =>
                  handleEditorChange(content, "exclusions")
                }
              />
            </div>
            <div>
              <label className="text-[16px] font-semibold mb-4 block">
                Terms and Conditions<span className="text-red-500">*</span>
              </label>
              <TextEditor
                initialValue={editorContents.terms_conditions}
                onChange={(content) =>
                  handleEditorChange(content, "terms_conditions")
                }
              />
            </div>
            <div>
              <label className="text-[16px] font-semibold mb-4 block">
                Learning Outcomes<span className="text-red-500">*</span>
              </label>
              <TextEditor
                initialValue={editorContents.learning_outcomes}
                onChange={(content) =>
                  handleEditorChange(content, "learning_outcomes")
                }
              />
            </div>

            <div>
              <label className="text-[16px] font-semibold mb-4 block">
                Payment Plan
              </label>
              <TextEditor
                initialValue={editorContents.payment_plan}
                onChange={(content) =>
                  handleEditorChange(content, "payment_plan")
                }
              />
            </div>

            <div>
              <label className="text-[16px] font-semibold mb-4 block">
                Cancellation Policy
              </label>
              <TextEditor
                initialValue={editorContents.cancellation_policy}
                onChange={(content) =>
                  handleEditorChange(content, "cancellation_policy")
                }
              />
            </div>

            <div>
              <label className="text-[16px] font-semibold mb-4 block">
                Notes
              </label>
              <TextEditor
                initialValue={editorContents.notes}
                onChange={(content) =>
                  handleEditorChange(content, "notes")
                }
              />
            </div>
          </div>
        </div>
        {isModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
            <div className="bg-white rounded-lg p-6 w-96">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold">Convert to Itinerary</h2>
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <span className="material-symbols-outlined">close</span>
                </button>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="text-[16px] font-semibold mb-2 block">
                    Itinerary Name<span className="text-red-500">*</span>
                  </label>
                  <InputText
                    placeholder="Enter itinerary name..."
                    value={itineraryName}
                    onChange={(e) => setItineraryName(e.target.value)}
                  />
                </div>

                <div>
                  <label className="text-[16px] font-semibold mb-2 block">
                    Select Institution
                    <span className="text-red-500">*</span>
                  </label>
                  <Select
                    options={institutionOptions}
                    onChange={handleInstitutionSelect}
                    value={selectedInstitution}
                    placeholder="Select Institution..."
                  />
                </div>
              </div>

              <div className="flex justify-end gap-2 mt-6">
                <Button
                  type="secondary"
                  label="Cancel"
                  onClick={() => setIsModalOpen(false)}
                />
                <Button
                  type="primary"
                  label="Add Enquiry"
                  onClick={handleConvertToEnquiry}
                  disabled={!selectedInstitution || !itineraryName}
                />
              </div>
            </div>
          </div>
        )}
      </Paper>
      <ToastContainer />
      <Paper className="my-8 pt-6 pb-6 px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {/* Declaration */}
          <div className="col-span-1 lg:col-span-4 mb-4">
            <label className="flex items-start gap-2">
              <input
                type="checkbox"
                className="mt-1"
                checked={isDeclarationChecked}
                onChange={(e) => setIsDeclarationChecked(e.target.checked)}
              />
              <span className="text-sm">
                I hereby declare that the above information is true and accurate
                to the best of my knowledge and belief.
              </span>
            </label>
          </div>

          {isDeclarationChecked && (
            <>
              {/* Representative Name */}
              <div>
                <label className="text-[16px] font-semibold mb-2 block">
                  Representative Name <span className="text-red-500">*</span>
                </label>
                <InputText
                  placeholder="Enter Representative Name..."
                  name="representative"
                  value={formValues.representative}
                  onChange={handleInputChange}
                />
              </div>

              {/* School */}
              <div>
                <label className="text-[16px] font-semibold mb-2 block">
                  Institution Name <span className="text-red-500">*</span>
                </label>
                <InputText
                  placeholder="Enter Institution Name"
                  name="school"
                  value={formValues.school}
                  onChange={handleInputChange}
                />
              </div>

              {/* Date */}
              <div>
                <label className="text-[16px] font-semibold mb-2 block">
                  Date <span className="text-red-500">*</span>
                </label>
                <DatePicker
                  selectedDate={selectedRepresentDate}
                  onDateChange={handleRepresentDateChange}
                  placeholder="Date"
                />
              </div>

              {/* Signature */}
              <div>
                <label className="text-sm font-semibold block mb-2">
                  Signature <span className="text-red-500">*</span>
                </label>
                <div className="relative border border-gray-300 rounded-md">
                  <SignatureCanvas
                    ref={(ref) => {
                      sigCanvas.current = ref;
                      if (
                        ref &&
                        isEdit &&
                        dropdownDataLoaded &&
                        freshItinerary?.itinerary_sign
                      ) {
                        ref.fromDataURL(freshItinerary.itinerary_sign);
                      }
                    }}
                    penColor="black"
                    canvasProps={{
                      width: 300,
                      height: 120,
                      className: "rounded-md",
                    }}
                  />
                </div>
                <button
                  type="button"
                  onClick={clearSignature}
                  className="text-red-500 mt-2 block text-sm font-medium hover:no-underline focus:outline-none border-none"
                  style={{ cursor: "pointer" }}
                >
                  Clear
                </button>
              </div>
            </>
          )}
        </div>
      </Paper>
    </div>
  );
};

export default AddItinerary;
